import { Scale } from "chart.js";
import React from "react";
export const MaystroSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 40 40"
  >
    <g transform="translate(-4898 -3846)">
      <g transform="translate(4906.093 3854.617)">
        <path
          className="b"
          d="M70.1,48.093c0,6.628,0,6.84.08,7,.106.212.265.345.663.583.186.106.451.265.61.371a1.778,1.778,0,0,0,.292.159,2.877,2.877,0,0,1,.345.212,4.124,4.124,0,0,0,.371.212.057.057,0,0,1,.053.053.057.057,0,0,0,.053.053,1.478,1.478,0,0,1,.371.212c.186.106.345.212.345.212a1.108,1.108,0,0,1,.292.186,1.617,1.617,0,0,0,.318.186c.027,0,.053.027.08.027a1.96,1.96,0,0,0,.583.265c.053,0,.08-.451.08-4.375A41.4,41.4,0,0,1,74.69,49.1a3.048,3.048,0,0,0,.292.186c.133.08.371.212.557.318.636.371.716.4.981.53a1.981,1.981,0,0,1,.318.186c.027.027.133.08.265.159s.371.212.557.318a2,2,0,0,0,.4.186.026.026,0,0,1,.027.027c0,.026.053.053.133.08a2.386,2.386,0,0,1,.371.186,4.288,4.288,0,0,0,.477.265,1.766,1.766,0,0,0,.292.159c.053.027.345.212.822.451a2.8,2.8,0,0,1,.345.212.7.7,0,0,0,.239.133c.159.08.636.345.716.4.027.027.159.08.292.159s.345.186.451.239a1.3,1.3,0,0,0,.265.106,23.654,23.654,0,0,0,.053-2.466c0-2.678,0-2.625-.239-2.837a2.512,2.512,0,0,0-.61-.371c-.106-.053-.318-.186-.5-.292s-.345-.186-.345-.186a1.2,1.2,0,0,1-.239-.133c-.133-.08-.318-.186-.4-.239-.159-.08-.9-.5-1.458-.822a4.779,4.779,0,0,1-.477-.265,2.933,2.933,0,0,1-.345-.186,1.979,1.979,0,0,0-.318-.186c-.159-.08-.5-.265-.769-.424-.292-.159-.583-.318-.689-.4-.106-.053-.318-.186-.477-.265a3.614,3.614,0,0,0-.53-.292c-.133-.08-.424-.239-.663-.371S74.028,43.4,74,43.4a.41.41,0,0,1-.159-.08,1.684,1.684,0,0,0-.318-.186c-.106-.053-.292-.159-.4-.212-.212-.133-1.485-.848-1.829-1.034-.133-.08-.4-.212-.583-.345a3.722,3.722,0,0,0-.477-.239l-.106-.027v6.814m24.922-6.628c-.186.106-.53.292-.742.424s-.4.239-.4.239-.133.08-.292.186a1.614,1.614,0,0,1-.318.186,1.768,1.768,0,0,0-.292.159c-.159.08-.4.239-.557.318s-.318.186-.371.212c-.186.106-.663.371-.742.4a.329.329,0,0,0-.08.053.026.026,0,0,1-.027.027s-.239.106-.477.239-.451.239-.451.239a2.058,2.058,0,0,0-.186.106c-.159.106-.371.212-.822.477-.371.212-1.167.663-1.432.822l-.265.159a1.615,1.615,0,0,0-.318.186,1.615,1.615,0,0,1-.318.186,2.1,2.1,0,0,0-.265.133c-.133.08-.318.186-.424.239s-.265.159-.345.186c-.08.053-.265.133-.4.212s-.318.186-.4.239-.292.159-.424.239c-.928.5-.954.53-1.167.636-.4.239-.4.239-.4,3,0,2.466,0,2.519.159,2.36a1.267,1.267,0,0,1,.292-.159c.239-.133.451-.239.954-.53.133-.08.239-.133.265-.159a1.981,1.981,0,0,1,.318-.186c.292-.159.477-.265.981-.557.159-.106.424-.239.557-.318a1.768,1.768,0,0,1,.292-.159,2.368,2.368,0,0,0,.345-.212c.159-.08.371-.212.451-.239a3.385,3.385,0,0,1,.318-.186c.08-.053.186-.106.212-.133s.212-.106.4-.212.4-.212.451-.239.106-.053.106-.08c0,0,.08-.053.133-.08s.212-.106.345-.186.477-.265.8-.451l.557-.318V53.29a41.217,41.217,0,0,0,.053,4.4,2.278,2.278,0,0,0,.477-.212c.212-.133.424-.239.424-.239s.159-.08.345-.186.583-.345.875-.5c.292-.186.663-.4.8-.477s.345-.186.451-.265c.742-.424.981-.61,1.061-.8.133-.318.106-13.839,0-13.813-.133.08-.318.159-.5.265"
          transform="translate(-70.104 -33.894)"
        />
        <path
          className="b"
          d="M117.975,13.739a.756.756,0,0,1-.212.106.093.093,0,0,0-.053.027.1.1,0,0,1-.08.053l-.371.186c-.159.08-.371.212-.477.265s-.239.133-.292.159a3.791,3.791,0,0,1-.5.265c-.212.106-.451.239-.53.292s-.265.159-.424.239c-.371.186-.981.557-1.326.742a2.385,2.385,0,0,1-.371.186c-.08.027-.133.053-.133.08s-.159.08-.318.159c-.4.212-.53.292-.61.345a.508.508,0,0,1-.212.106.361.361,0,0,0-.159.08c0,.027-.053.053-.106.08-.5.265-.9.477-1.405.769-.954.53-1.034.557-1.273.689-1.7.954-2.519,1.405-2.7,1.511-.133.08-.239.133-.239.159,0,.053,0,.053.371-.133.345-.159.53-.239.928-.424.133-.053.371-.159.53-.239.186-.08.451-.212.61-.265a1.1,1.1,0,0,0,.318-.159,6.734,6.734,0,0,1,.769-.345c.4-.186.9-.4,1.087-.477s.53-.239.742-.318.477-.212.61-.265c.265-.133.583-.265,1.06-.477.424-.186.928-.424,1.379-.636.186-.08.318-.159.345-.159a9.042,9.042,0,0,0,.9-.4c.8-.371.954-.451.981-.451,0,0,.186-.08.4-.186.875-.424,1.007-.451,1.167-.371q.994.477,1.511.716c.689.318,1.723.822,2.757,1.326.424.186,1.432.689,1.829.875.159.08.5.239.8.371,1.007.477,1.405.663,1.856.875.239.106.689.318.981.477.292.133.769.371,1.06.5a1.874,1.874,0,0,0,.557.212c.027-.027,0-.027-.027-.053a2.367,2.367,0,0,1-.345-.212,3.357,3.357,0,0,0-.318-.186,4.111,4.111,0,0,1-.371-.212,2.577,2.577,0,0,0-.451-.239c-.053-.027-.106-.053-.106-.08a.093.093,0,0,0-.027-.053c-.027,0-1.061-.583-1.405-.822a1.442,1.442,0,0,0-.212-.106c-.027,0-.61-.345-1.22-.689a3.63,3.63,0,0,0-.477-.265s-.239-.133-.477-.292c-.265-.159-.477-.292-.477-.292s-.186-.106-.424-.239c-.212-.133-.5-.292-.61-.345s-.292-.159-.4-.212-.212-.133-.239-.133c-.026-.027-.186-.106-.345-.212a3.19,3.19,0,0,0-.318-.159.057.057,0,0,1-.053-.053c0-.027-.053-.053-.08-.08a3.513,3.513,0,0,1-.371-.212,3.355,3.355,0,0,0-.318-.186.057.057,0,0,1-.053-.053.057.057,0,0,0-.053-.053,1.477,1.477,0,0,1-.371-.212c-.186-.106-.4-.239-.477-.292-.4-.212-.875-.5-.9-.53a.718.718,0,0,0-.822-.08"
          transform="translate(-105.7 -13.645)"
        />
      </g>
    </g>
  </svg>
);
export const DeletSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 25 25"
  >
    <g transform="translate(0.094 -0.156)">
      <path
        d="M448.844-330.5a1.692,1.692,0,0,0,1.688,1.688h6.75a1.692,1.692,0,0,0,1.688-1.687v-10.125H448.844V-330.5Zm10.969-12.656h-2.953l-.844-.844H451.8l-.844.844H448v1.688h11.813v-1.687Z"
        transform="translate(-441.25 349.063)"
      />
    </g>
  </svg>
);
export const AddSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 25 25"
  >
    <g transform="translate(-4548 -3846)">
      <path
        d="M499.464-255.449h-4.913v4.913h-1.638v-4.913H488v-1.638h4.913V-262h1.638v4.913h4.913v1.638Z"
        transform="translate(4066.551 4114.551)"
      />
    </g>
  </svg>
);
export const ViewSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 25 25"
  >
    <g transform="translate(-800 -439)">
      <path
        d="M533.152-102.5A9.84,9.84,0,0,0,524-96.26a9.84,9.84,0,0,0,9.152,6.24,9.84,9.84,0,0,0,9.152-6.24,9.84,9.84,0,0,0-9.152-6.24Zm0,10.4a4.161,4.161,0,0,1-4.16-4.16,4.161,4.161,0,0,1,4.16-4.16,4.161,4.161,0,0,1,4.16,4.16,4.161,4.161,0,0,1-4.16,4.16Zm0-6.656a2.493,2.493,0,0,0-2.5,2.5,2.493,2.493,0,0,0,2.5,2.5,2.493,2.493,0,0,0,2.5-2.5,2.493,2.493,0,0,0-2.5-2.5Z"
        transform="translate(279.328 548.156)"
      />
    </g>
  </svg>
);

export const PrintSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 30 30"
  >
    <g transform="translate(-5248 -3746)">
      <path
        d="M1062-339h-14a3,3,0,0,0-3,3v6h4v4h12v-4h4v-6A3,3,0,0,0,1062-339Zm-3,11h-8v-5h8Zm3-7a1,1,0,0,1-1-1,1,1,0,0,1,1-1,1,1,0,0,1,1,1A1,1,0,0,1,1062-335Zm-1-9h-12v4h12Z"
        transform="translate(4208 4096)"
      />
    </g>
  </svg>
);
export const AddProductSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 25 25"
  >
    <g transform="translate(-4648 -3846)">
      <path
        d="M-4707.4-411.809l-5.546-3.406v-8.514l3.052-1.741,7.521,4.291v1.32a6.169,6.169,0,0,1,.672-.037,6.175,6.175,0,0,1,.644.034v-2.118l-7.446-4.284,3.044-1.736,7.488,4.271v5.108a6,6,0,0,1,2.335,4.748,6.046,6.046,0,0,1-6.065,6.023A6.067,6.067,0,0,1-4707.4-411.809Zm.848-2.063a4.841,4.841,0,0,0,4.851,4.819,4.842,4.842,0,0,0,4.853-4.819,4.842,4.842,0,0,0-4.853-4.818A4.84,4.84,0,0,0-4706.554-413.873Zm-3.539-4.359a.84.84,0,0,0,.345.669l1.987,1.139c.189.109.345-.015.345-.274a.838.838,0,0,0-.345-.669l-1.987-1.139a.266.266,0,0,0-.132-.04C-4710-418.545-4710.093-418.427-4710.093-418.231Zm7.784,7.37v-2.408h-2.426v-1.205h2.426v-2.409h1.212v2.409h2.426v1.205h-2.426v2.408Z"
        transform="translate(9365.179 4276.39)"
      />
    </g>
  </svg>
);
export const EditSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 25 25"
  >
    <g transform="translate(-500 -389)">
      <path
        d="M286-132.334v3.069h3.069l9.053-9.053-3.069-3.069L286-132.334Zm14.5-8.357a.815.815,0,0,0,0-1.154l-1.915-1.915a.815.815,0,0,0-1.154,0l-1.5,1.5L299-139.193l1.5-1.5Z"
        transform="translate(218.911 537.911)"
      />
    </g>
  </svg>
);
export const WarningSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 30 30"
  >
    <g transform="translate(-4748 -3796)">
      <path
        d="M644-286h22l-11-19-11,19Zm12-3h-2v-2h2v2Zm0-4h-2v-4h2v4Z"
        transform="translate(4108 4106)"
      />
    </g>
  </svg>
);
export const PackageSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 40 40"
  >
    <g transform="translate(-4248 -3846)">
      <path
        d="M21.92,3.8,16.977,6.635l12.09,7.006V18.71l-2.136,1.233V14.95L14.717,7.934,9.762,10.78V24.7L21.92,31.719,34.079,24.7V10.78Zm-3.733,18.93L14.96,20.864a1.376,1.376,0,0,1-.561-1.1c0-.424.253-.626.561-.448l3.226,1.862a1.376,1.376,0,0,1,.561,1.1C18.747,22.7,18.494,22.9,18.187,22.726Z"
        transform="translate(4245.921 3848.871)"
      />
    </g>
  </svg>
);
export const CarSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 40 40"
  >
    <g transform="translate(-900 -439)">
      <path
        d="M627.227-101.653A1.992,1.992,0,0,0,625.333-103H610.667a2,2,0,0,0-1.893,1.347L606-93.667V-83a1.337,1.337,0,0,0,1.333,1.333h1.333A1.337,1.337,0,0,0,610-83v-1.333h16V-83a1.337,1.337,0,0,0,1.333,1.333h1.333A1.337,1.337,0,0,0,630-83V-93.667l-2.773-7.987Zm-16.56,13.32a2,2,0,0,1-2-2,2,2,0,0,1,2-2,2,2,0,0,1,2,2,2,2,0,0,1-2,2Zm14.667,0a2,2,0,0,1-2-2,2,2,0,0,1,2-2,2,2,0,0,1,2,2,2,2,0,0,1-2,2ZM608.667-95l2-6h14.667l2,6Z"
        transform="translate(302 551.333)"
      />
    </g>
  </svg>
);
export const TruckSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 29 29"
  >
    <g transform="translate(-2676 -55.269)">
      <path
        className="b"
        d="M16146.472,1938.041h-.78v-8.911h2.472a3.9,3.9,0,0,1,3.9,3.9v4.228a.78.78,0,0,1-.779.781h-1.562a1.626,1.626,0,1,1-3.252,0Zm-15.284,0h-2.406a.781.781,0,0,1-.781-.781v-14.5a.781.781,0,0,1,.781-.781h14.5a.781.781,0,0,1,.78.781v15.285h-9.626a1.626,1.626,0,1,1-3.252,0Z"
        transform="translate(-13448.813 -1860.212)"
      />
    </g>
  </svg>

  // <svg xmlns="http://www.w3.org/2000/svg" className="StSvgCl" viewBox="0 0 29 29"><g transform="translate(-2676 -55.269)"><rect className="a" width="29" height="29" transform="translate(2676 55.269)"/><path className="b" d="M16146.472,1938.041h-.78v-8.911h2.472a3.9,3.9,0,0,1,3.9,3.9v4.228a.78.78,0,0,1-.779.781h-1.562a1.626,1.626,0,1,1-3.252,0Zm-15.284,0h-2.406a.781.781,0,0,1-.781-.781v-14.5a.781.781,0,0,1,.781-.781h14.5a.781.781,0,0,1,.78.781v15.285h-9.626a1.626,1.626,0,1,1-3.252,0Z" transform="translate(-13448.813 -1860.212)"/></g></svg>
);
export const PickupSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
  >
    <g>
      <g>
        <g>
          <path d="m4.25 8.001c-.413 0-.75-.336-.75-.75s.337-.75.75-.75.75.337.75.75-.337.75-.75.75z" />
        </g>
      </g>
    </g>
    <g>
      <g>
        <g>
          <path d="m8.776 8.001c-.413 0-.75-.336-.75-.75s.337-.75.75-.75.75.337.75.75-.337.75-.75.75z" />
        </g>
      </g>
    </g>
    <g>
      <g>
        <g>
          <path d="m6.506 11.005c-.675 0-1.31-.263-1.786-.741-.195-.195-.195-.512 0-.707.195-.194.512-.195.707.001.576.577 1.582.577 2.158 0 .195-.196.512-.195.707-.001.195.195.195.512 0 .707-.477.478-1.111.741-1.786.741z" />
        </g>
      </g>
    </g>
    <g>
      <g>
        <g>
          <path d="m.501 6.498c-.153 0-.304-.07-.402-.202-.163-.221-.119-.533.102-.697.087-.065 2.191-1.602 6.305-1.602s6.207 1.537 6.295 1.603c.22.166.264.477.1.698-.165.221-.477.268-.699.103-.019-.014-1.942-1.403-5.695-1.403-3.754 0-5.689 1.39-5.708 1.404-.091.064-.195.096-.298.096z" />
        </g>
      </g>
    </g>
    <g>
      <g>
        <g>
          <path d="m6.506 13.01c-1.634 0-2.996-.557-4.05-1.656-1.225-1.274-1.956-3.268-1.956-5.331 0-.042.005-.083.015-.122l.724-3.28c.208-.939.946-1.685 1.883-1.9l2.826-.648c.363-.084.751-.084 1.118 0l2.814.648c.937.216 1.675.961 1.881 1.9l.728 3.294c.007.036.011.072.011.108v.151c0 1.53-.511 3.694-1.943 5.181-1.059 1.098-2.422 1.655-4.051 1.655zm-5.006-6.934c.014 1.406.46 3.318 1.677 4.586.858.895 1.979 1.348 3.329 1.348 1.348 0 2.468-.454 3.33-1.349 1.226-1.273 1.664-3.153 1.664-4.487v-.096l-.716-3.241c-.124-.564-.567-1.012-1.129-1.141l-2.814-.648c-.218-.05-.451-.05-.671 0l-2.825.648c-.562.129-1.005.577-1.13 1.141z" />
        </g>
      </g>
    </g>
    <g>
      <g>
        <g>
          <path d="m5.388 22h-2.888c-.276 0-.5-.224-.5-.5v-8c0-.276.224-.5.5-.5s.5.224.5.5v7.5h2.388c.276 0 .5.224.5.5s-.224.5-.5.5z" />
        </g>
      </g>
    </g>
    <g>
      <g>
        <g>
          <path d="m16.5 22h-7c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h6.5v-10h-2.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h3c.276 0 .5.224.5.5v11c0 .276-.224.5-.5.5z" />
        </g>
      </g>
    </g>
    <g>
      <g>
        <g>
          <path d="m23.5 22h-2c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h1.5v-3.48c0-1.638-1.332-2.97-2.97-2.97h-3.03v6.45h.5c.276 0 .5.224.5.5s-.224.5-.5.5h-1c-.276 0-.5-.224-.5-.5v-7.45c0-.276.224-.5.5-.5h3.53c2.188 0 3.97 1.781 3.97 3.97v3.98c0 .276-.224.5-.5.5z" />
        </g>
      </g>
    </g>
    <g>
      <g>
        <g>
          <path d="m7.5 24c-1.379 0-2.5-1.122-2.5-2.5s1.121-2.5 2.5-2.5 2.5 1.122 2.5 2.5-1.121 2.5-2.5 2.5zm0-4c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5z" />
        </g>
      </g>
    </g>
    <g>
      <g>
        <g>
          <path d="m19.5 24c-1.379 0-2.5-1.122-2.5-2.5s1.121-2.5 2.5-2.5 2.5 1.122 2.5 2.5-1.121 2.5-2.5 2.5zm0-4c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5z" />
        </g>
      </g>
    </g>
  </svg>
);
export const PriceSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 40 40"
  >
    <g transform="translate(-4248 -3846)">
      <path
        d="M13.095,33.34h.022a1.27,1.27,0,0,0,.892-.384l1.547-1.607,1.766-1.826,5.507-5.7a1.27,1.27,0,0,0,.289-.435l.5-1.34,1.321-3.557.441-1.188a1.27,1.27,0,0,0-.318-1.359l-.254-.245L22.82,13.776h0L20.6,11.629a1.251,1.251,0,0,0-.883-.359,1.2,1.2,0,0,0-.486.1l-6,2.484a1.207,1.207,0,0,0-.429.3L3.98,23.272a1.27,1.27,0,0,0,.032,1.791l8.2,7.921A1.27,1.27,0,0,0,13.095,33.34Zm3-14.762a1.906,1.906,0,0,1,1.366-1.416,1.814,1.814,0,0,1,.489-.064,1.88,1.88,0,0,1,1.359.556,1.906,1.906,0,1,1-3.2.924Z"
        transform="translate(4250.542 3842.73)"
      />
      <path
        d="M59.32,19.67l-1.995-1.925L55.1,15.6a1.251,1.251,0,0,0-.883-.359,1.2,1.2,0,0,0-.486.1l-.578.238a.635.635,0,0,0-.2,1.045l.892.864.26.248a2.541,2.541,0,0,1,.613,2.712l-.441,1.191L52.946,25.2l-.5,1.34a2.588,2.588,0,0,1-.543.873l-5.517,5.7L45.06,34.483a.635.635,0,0,0,0,.9L46.7,36.97a1.27,1.27,0,0,0,.883.356H47.6a1.27,1.27,0,0,0,.892-.384l1.547-1.607,1.766-1.826,5.52-5.707a1.271,1.271,0,0,0,.289-.435l.5-1.34,1.321-3.557.441-1.188a1.27,1.27,0,0,0-.318-1.359Z"
        transform="translate(4222.395 3840.021)"
      />
    </g>
  </svg>
);
export const LocationSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 40 40"
  >
    <g transform="translate(-1300 -439)">
      <path
        d="M937.333-105A9.327,9.327,0,0,0,928-95.667c0,7,9.333,17.333,9.333,17.333s9.333-10.333,9.333-17.333A9.327,9.327,0,0,0,937.333-105Zm0,12.667A3.335,3.335,0,0,1,934-95.667,3.335,3.335,0,0,1,937.333-99a3.335,3.335,0,0,1,3.333,3.333,3.335,3.335,0,0,1-3.333,3.333Z"
        transform="translate(382.667 550.667)"
      />
    </g>
  </svg>
);
export const PersonSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 40 40"
  >
    <g transform="translate(-400 -539)">
      <path
        d="M220-10a6.5,6.5,0,0,0,6.5-6.5A6.5,6.5,0,0,0,220-23a6.5,6.5,0,0,0-6.5,6.5A6.5,6.5,0,0,0,220-10Zm0,3.25c-4.339,0-13,2.178-13,6.5V3h26V-.25c0-4.322-8.661-6.5-13-6.5Z"
        transform="translate(200 569)"
      />
    </g>
  </svg>
);
export const StoreSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 19.721 19.115"
  >
    <path
      d="M34.018,14.053l1.876,4.818a3.664,3.664,0,0,1,.556,1.927,3.575,3.575,0,0,1-.471,1.784V32.2a.591.591,0,0,1-.591.591h-17.6A.593.593,0,0,1,17.2,32.2V22.581a3.634,3.634,0,0,1,.089-3.714L19.143,14.1a.594.594,0,0,1,.568-.425H33.47v0A.588.588,0,0,1,34.018,14.053ZM25.285,31.608c.046-1.212-.027-2.614-.027-3.791a1.626,1.626,0,1,0-3.247,0v3.791Zm9.671-11.9-1.888-4.853H30.3v4.853Zm-5.838-4.853h-5.1v4.853h5.1V14.856Zm-6.285,0H20.112L18.22,19.709h4.614V14.856ZM35.269,20.89h-5a2.509,2.509,0,0,0,4.641,1.189A2.466,2.466,0,0,0,35.269,20.89Zm-6.189,0H24.1a2.507,2.507,0,0,0,4.266,1.66A2.38,2.38,0,0,0,29.08,20.89Zm-6.177,0H17.911a2.515,2.515,0,0,0,4.278,1.66A2.344,2.344,0,0,0,22.9,20.89Zm10.073,5.266H29v2.208h3.977Z"
      transform="translate(-16.73 -13.674)"
    />
  </svg>
);
export const PeopleSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 490.667 490.667"
  >
    <g>
      <g>
        <circle cx="245.333" cy="160" r="74.667" />
      </g>
    </g>
    <g>
      <g>
        <circle cx="394.667" cy="224" r="53.333" />
      </g>
    </g>
    <g>
      <g>
        <circle cx="97.515" cy="224" r="53.333" />
      </g>
    </g>
    <g>
      <g>
        <path d="M245.333,256c-76.459,0-138.667,62.208-138.667,138.667c0,5.888,4.779,10.667,10.667,10.667h256 c5.888,0,10.667-4.779,10.667-10.667C384,318.208,321.792,256,245.333,256z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M115.904,300.971c-6.528-1.387-13.163-2.304-19.904-2.304c-52.928,0-96,43.072-96,96c0,5.888,4.779,10.667,10.667,10.667 h76.629c-1.195-3.349-1.963-6.912-1.963-10.667C85.333,359.659,96.768,327.339,115.904,300.971z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M394.667,298.667c-6.741,0-13.376,0.917-19.904,2.304c19.136,26.368,30.571,58.688,30.571,93.696 c0,3.755-0.768,7.317-1.963,10.667H480c5.888,0,10.667-4.779,10.667-10.667C490.667,341.739,447.595,298.667,394.667,298.667z" />
      </g>
    </g>
  </svg>
);
export const DriveHbSvg = (
  <svg
    viewBox="0 0 512 512"
    className="StSvgCl"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="m361 211h-60v88.486l-30-18.99v-129.496h60v-151h-150v151h60v129.496l-30 18.99v-88.486h-60v-60h-151v150h151v-60h30v77.477l-14.996 9.492 89.996 59.999 89.996-59.998-14.996-9.493v-77.477h30v60h151v-150h-151zm-120-150h30v30h-30zm-150 180h-30v-30h30zm330-30h30v30h-30z" />
    <path d="m271 414.031v97.969l90-60.004v-97.97z" />
    <path d="m151 354.026v97.97l90 60.004v-97.969z" />
  </svg>
);
export const MoneySubSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 489.9 489.9"
  >
    <g>
      <g>
        <g>
          <path d="M386.458,272.6c-5.5-4.3-62.9-68-78.4-77V30.3c0-16.8-13.6-30.3-30.3-30.3h-156.1c-16.8,0-30.3,13.6-30.3,30.3v289.4 c0,16.8,13.6,30.3,30.3,30.3h50.1h17.9l-2.8-23.8c-0.9-0.8-1.5-1.3-2.4-2.1h-10h-20c1-4,1.3-8.4,0.5-12.9 c-2.2-12.5-12.1-22.6-24.6-24.9c-4.6-0.9-9.1-0.6-13.2,0.4V61.4c1.8,0.3,3.7,0.5,5.6,0.5c17,0,30.7-13.8,30.7-30.7 c0-1.8-0.2-3.6-0.5-5.4h93.2c-0.3,1.8-0.5,3.6-0.5,5.4c0,17,13.7,30.7,30.7,30.7c1.9,0,3.8-0.2,5.6-0.5v219.9l0,0v63.2 c-10.6-7.8-22.4-32.2-22.4-32.2s-5.8-64.9-38.7-64.9c-0.9,0-1.7,0-2.6,0.1c0,0-24.9,2.1-4.3,73.3l9.2,79.1 c0,0,10.3,42.9,38.7,72.6v8.8c0,4.7,3.8,8.6,8.6,8.6h92.5c4.4,0,8-3.3,8.5-7.6c3.3-30.8,16.1-145.3,23.6-162.7 c1.2-2.8,2.2-5.6,2.6-8.6C399.358,301.2,399.958,283.2,386.458,272.6z" />
        </g>
        <g>
          <circle cx="203.058" cy="80.3" r="18.4" />
        </g>
        <g>
          <g>
            <path d="M133.258,177.1c0,31.7,22.2,58.2,51.9,64.9c0.9-1.7,1.8-3.2,2.9-4.8c9.8-14.3,23.1-16.9,27.6-17.3 c1.8-0.2,3.6-0.3,5.4-0.3c6.4,0,15.1,1.2,24.1,6c12.9-12.1,21-29.4,21-48.5c0-36.7-29.8-66.5-66.5-66.5 S133.258,140.4,133.258,177.1z M159.858,171.2c4,0,4.1,0,4.7-4c0.5-3.1,1.4-6,2.6-8.9c0.7-1.6,1.8-2.2,3.4-1.7 c2.5,0.7,4.9,1.4,7.4,2.2c2.3,0.7,2.6,1.5,1.6,3.7c-2.2,4.5-3.1,9.1-2.8,14.1c0.1,1.3,0.2,2.6,0.8,3.7c1.9,4.3,6.6,4.9,9.5,1.3 c1.5-1.8,2.5-3.9,3.4-6.1c1.6-3.8,3.1-7.6,5-11.1c6.3-11.4,20.6-14.5,30.4-6.4c3.5,2.9,5.9,6.7,7.1,11.1 c0.5,1.9,1.5,2.8,3.5,2.7s3.9,0,5.9,0c1.8,0,2.7,0.9,2.7,2.6c0.1,2.1,0.1,4.2,0,6.3c0,1.9-1.1,2.7-2.9,2.7c-1.4,0-2.9,0-4.3,0 c-3.2,0-3.3,0.1-3.8,3.2c-0.6,3.9-1.5,7.7-3.2,11.3c-1.4,2.8-2.1,3.1-5,2.3c-2.2-0.6-4.4-1.2-6.5-1.9c-2.5-0.8-2.8-1.5-1.6-3.8 c2.1-3.9,3.2-8.1,3.8-12.5c0.4-2.8,0.1-5.6-1.1-8.2c-2.1-4.9-7.8-5.7-11.2-1.5c-1.2,1.4-2,3-2.7,4.7c-1.9,4.3-3.3,8.8-5.7,12.8 c-3.9,6.6-9.3,10.7-17.3,10.2c-9-0.5-14.7-5.7-17.7-13.9c-1.2-3.4-1.2-3.4-4.8-3.5c-1.2,0-2.4,0-3.6,0c-2.7-0.1-3.2-0.5-3.2-3.2 c0-0.8,0-1.7,0-2.5C154.158,171.3,154.158,171.3,159.858,171.2z" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export const CachbackSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 25 25"
  >
    <g transform="translate(0 1)">
      <path
        className="b"
        d="M21.2,16.428v2.02a.636.636,0,0,1-.673.673h-2.02A2.7,2.7,0,0,1,21.2,16.428Zm0-6.734V7.673A.636.636,0,0,0,20.529,7h-2.02A2.7,2.7,0,0,0,21.2,9.694ZM1,16.428v2.02a.636.636,0,0,0,.673.673h2.02A2.7,2.7,0,0,0,1,16.428ZM3.694,7H1.673A.636.636,0,0,0,1,7.673v2.02A2.7,2.7,0,0,0,3.694,7ZM17.162,19.122H5.041A4.052,4.052,0,0,0,1,15.081V11.041A4.052,4.052,0,0,0,5.041,7H17.162A4.052,4.052,0,0,0,21.2,11.041v4.041A4.052,4.052,0,0,0,17.162,19.122Zm-2.694-5.387a2.7,2.7,0,0,0-2.694-2.694H10.7l.2-.2A.667.667,0,1,0,9.957,9.9L8.61,11.243c-.067.067-.135.135-.135.2a.738.738,0,0,0,0,.539c0,.067.067.135.135.2l1.347,1.347a.651.651,0,0,0,.943,0h0a.651.651,0,0,0,0-.943h0l-.2-.2h1.077a1.347,1.347,0,0,1,0,2.694H9.081a.673.673,0,1,0,0,1.347h2.694A2.7,2.7,0,0,0,14.469,13.734Z"
        transform="translate(1.53 -1.282)"
      />
    </g>
  </svg>
);
export const ExchangeSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 25 25"
  >
    <g transform="translate(-5298 -3796)">
      <g transform="translate(5301.45 3800)">
        <path
          className="b"
          d="M42.123,9.464a.7.7,0,0,0,1.009,0,.729.729,0,0,0,0-1.009l-.937-.937h4.686v5.515a.7.7,0,0,0,1.406,0V6.8a.7.7,0,0,0-.7-.7H42.177l.937-.937a.729.729,0,0,0,0-1.009.712.712,0,0,0-1.009,0L39.978,6.31a.729.729,0,0,0,0,1.009Z"
          transform="translate(-33.057 -3.937)"
        />
        <path
          className="b"
          d="M7.655,9.681V6.491A1,1,0,0,0,6.663,5.5H3.491a1,1,0,0,0-.991.991v3.19a1,1,0,0,0,.991.991h3.19A.985.985,0,0,0,7.655,9.681Z"
          transform="translate(-2.5 -5.218)"
        />
        <path
          className="b"
          d="M19.164,45.972a.729.729,0,0,0-1.009,0,.712.712,0,0,0,0,1.009l.937.937H14.406V42.4a.7.7,0,0,0-.7-.7.716.716,0,0,0-.7.7v6.218a.7.7,0,0,0,.7.7H19.11l-.937.937a.729.729,0,0,0,0,1.009.7.7,0,0,0,1.009,0l2.145-2.145a.729.729,0,0,0,0-1.009Z"
          transform="translate(-11.108 -34.894)"
        />
        <path
          className="b"
          d="M73.063,65.8H69.891a1,1,0,0,0-.991.991v3.19a1,1,0,0,0,.991.991h3.172a1,1,0,0,0,.991-.991v-3.19A1,1,0,0,0,73.063,65.8Z"
          transform="translate(-56.932 -54.65)"
        />
      </g>
    </g>
  </svg>
);
export const SubstitutionSvg = (
  <svg
    enableBackground="new 0 0 504.711 504.711"
    height="20"
    width="20"
    viewBox="0 0 504.711 504.711"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m310.94 213.514v-104.196c0-8.836-7.163-16-16-16h-140.049v-51.586c0-14.117-17.038-21.321-27.163-11.462l-122.893 119.684c-6.454 6.285-6.439 16.654 0 22.925l122.893 119.685c10.112 9.847 27.163 2.669 27.163-11.462v-51.586h140.049c8.837-.002 16-7.165 16-16.002z"
      fill="#e88793"
    />
    <path
      d="m499.876 331.833-122.892-119.685c-10.112-9.847-27.163-2.669-27.163 11.462v51.586h-140.049c-8.837 0-16 7.164-16 16v104.196c0 8.836 7.163 16 16 16h140.049v51.586c0 14.161 17.098 21.263 27.163 11.462l122.893-119.684c6.454-6.284 6.439-16.653-.001-22.923z"
      fill="#9bd65e"
    />
    <path
      d="m376.984 474.441 122.893-119.684c6.454-6.285 6.439-16.654 0-22.925l-15.447-15.043c-38.168 5.162-75.941 16.231-100.162 38.308-38.523 35.114-124.073 32.667-190.496 24.738v15.558c0 8.836 7.163 16 16 16h140.049v51.586c0 14.118 17.038 21.321 27.163 11.462z"
      fill="#91c656"
    />
    <path
      d="m173.263 149.352c34.795-23.187 68.925-41.608 99.612-56.033h-117.984v-51.587c0-14.117-17.038-21.321-27.163-11.462l-121.592 118.418c34.699 24.612 94.852 48.827 167.127.664z"
      fill="#fc93a0"
    />
  </svg>
);
export const HourglassSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 30 30"
  >
    <g transform="translate(-4548 -3746)">
      <path
        className="b"
        d="M100.515,71.332h-.283c-.361,0-.667-.05-.705-.411v-.006c-.811-7.549-5.566-7.694-5.566-9.471s4.761-1.922,5.566-9.471v-.006c.039-.361.344-.411.705-.411h.283a.8.8,0,0,0,.8-.739.779.779,0,0,0-.778-.817H82.783a.8.8,0,0,0-.8.739.779.779,0,0,0,.778.817h.306c.361,0,.667.05.706.411v.006c.811,7.549,5.566,7.694,5.566,9.471s-4.761,1.922-5.566,9.471v.006c-.039.361-.344.411-.706.411h-.283a.8.8,0,0,0-.8.739.779.779,0,0,0,.778.817h17.776a.775.775,0,0,0,.778-.817A.8.8,0,0,0,100.515,71.332ZM86.5,69.432c1.594-4.433,4.422-3.894,4.422-5.644V60.7c0-1.078-2.044-1.828-3.322-3.577a.435.435,0,0,1,.361-.689h7.383a.433.433,0,0,1,.372.678c-1.255,1.755-3.339,2.511-3.339,3.589v3.089c0,1.733,2.716,1.261,4.433,5.644.156.394.039.889-.383.889H86.883C86.455,70.321,86.355,69.832,86.5,69.432Z"
        transform="translate(4471.027 3699.216)"
      />
    </g>
  </svg>
);
export const CallSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 40 40"
  >
    <g transform="translate(-4248 -3846)">
      <path
        d="M250.666-253.96a19.525,19.525,0,0,0,8.494,8.494L262-248.3a1.282,1.282,0,0,1,1.315-.309,14.7,14.7,0,0,0,4.6.735,1.293,1.293,0,0,1,1.289,1.289v4.5a1.293,1.293,0,0,1-1.289,1.289A21.909,21.909,0,0,1,246-262.711,1.293,1.293,0,0,1,247.289-264H251.8a1.293,1.293,0,0,1,1.289,1.289,14.642,14.642,0,0,0,.735,4.6,1.294,1.294,0,0,1-.322,1.315l-2.836,2.836Z"
        transform="translate(4010.4 4118.4)"
      />
    </g>
  </svg>
);
export const EmailSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 64 64"
  >
    <g transform="translate(-4498.068 -3846.068)">
      <path
        d="M483.441-263h-34.17a4.266,4.266,0,0,0-4.25,4.271L445-233.1a4.284,4.284,0,0,0,4.271,4.271h34.17a4.284,4.284,0,0,0,4.271-4.271v-25.627A4.284,4.284,0,0,0,483.441-263Zm0,8.542-17.085,10.678-17.085-10.678v-4.271l17.085,10.678,17.085-10.678v4.271Z"
        transform="translate(4063.678 4123.949)"
      />
    </g>
  </svg>
);
export const ManagentSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 40 40"
  >
    <g transform="translate(-4248 -3846)">
      <path
        className="b"
        d="M14.149,12.6V9.422a1.271,1.271,0,0,1,1.271-1.27h5.459a1.271,1.271,0,0,1,1.271,1.27v.722h.272c2.054,0,2.156,1.13,2.156,1.13H22.149V12.6a4,4,0,1,1-8,0Zm7.718,13.519a1.74,1.74,0,0,0-1.74-1.739H14.872l-1.125-4.687,1.909,3.693h3.762v-1.53h6.665l-.81-3.374a1.736,1.736,0,0,0-1.692-1.328v-.015H11.765l0,.016a1.786,1.786,0,0,0-.41.042,1.74,1.74,0,0,0-1.285,2.1l1.735,7.23A1.74,1.74,0,0,0,13.5,27.858h6.626A1.74,1.74,0,0,0,21.866,26.118Zm1.93-3.766H19.915v1.033h.211a2.733,2.733,0,1,1,0,5.467h-.211v.286h11.71V22.352H23.8Zm-3.881,7.283h-.5v-.784H14.46l.287,1.247v2.819h8.834V29.636H19.915ZM32.122,24.4V27.84a1.73,1.73,0,0,0,0-3.443Z"
        transform="translate(4246.318 3845.441)"
      />
    </g>
  </svg>
);
export const CreatedSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 46 46"
  >
    <g transform="translate(-2166 -55)">
      <g transform="translate(2171.009 61.44)">
        <path
          className="b"
          d="M18.378,9.5a.838.838,0,0,0-.836-.836H13.414a1.191,1.191,0,0,1-1.187-1.187V3.336a.838.838,0,0,0-.836-.836H9.52a.838.838,0,0,0-.836.836V7.464A1.191,1.191,0,0,1,7.5,8.651H3.336a.838.838,0,0,0-.836.836v1.872a.838.838,0,0,0,.836.836H7.464a1.191,1.191,0,0,1,1.187,1.187v4.128a.838.838,0,0,0,.836.836h1.872a.838.838,0,0,0,.836-.836V13.414a1.191,1.191,0,0,1,1.187-1.187h4.128a.838.838,0,0,0,.836-.836Z"
          transform="translate(2.151 -2.5)"
        />
        <path
          className="b"
          d="M18261.588,1911.8a2.555,2.555,0,0,1-2.557-2.556h-1.227v-14h3.885a6.13,6.13,0,0,1,6.133,6.133v6.644a1.227,1.227,0,0,1-1.227,1.227h-2.453a2.554,2.554,0,0,1-2.555,2.556Zm-24.023,0a2.554,2.554,0,0,1-2.555-2.556h-3.783a1.226,1.226,0,0,1-1.227-1.227v-22.8a1.226,1.226,0,0,1,1.227-1.227h3.461a2.39,2.39,0,0,0-.65.348,2.419,2.419,0,0,0-.971,1.936v1.872a2.423,2.423,0,0,0,2.42,2.42h3.73v3.73a2.423,2.423,0,0,0,2.42,2.42h1.873a2.422,2.422,0,0,0,2.42-2.42v-3.7h3.73a2.434,2.434,0,0,0,2.23-1.467,2.35,2.35,0,0,0,.189-.925l.033-1.917a2.428,2.428,0,0,0-1.668-2.3h3.578a1.229,1.229,0,0,1,1.227,1.227v24.022h-15.129a2.554,2.554,0,0,1-2.557,2.556Z"
          transform="translate(-18230 -1879.298)"
        />
      </g>
    </g>
  </svg>
);
export const OutOfStockSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      stroke="none"
    >
      <path d="M2380 4650 c-203 -84 -1678 -746 -1672 -751 4 -5 156 -74 337 -155 302 -134 332 -145 359 -135 103 38 1734 767 1728 772 -4 3 -142 66 -307 139 -258 115 -308 134 -360 137 -33 1 -71 -2 -85 -7z" />
      <path d="M2565 3890 c-456 -203 -850 -379 -874 -390 l-45 -22 404 -179 403 -179 871 386 c479 212 874 389 878 393 7 6 -756 350 -792 357 -8 1 -388 -163 -845 -366z" />
      <path d="M532 2658 l3 -1073 22 -42 c13 -23 37 -53 55 -67 26 -19 1715 -776 1733 -776 3 0 5 502 5 1115 l0 1114 -27 15 c-62 31 -1772 786 -1782 786 -8 0 -11 -290 -9 -1072z" />
      <path d="M3453 3331 l-893 -396 1 -670 c1 -424 5 -648 10 -610 39 269 158 497 358 688 297 283 709 388 1111 282 54 -14 146 -50 213 -83 l117 -59 0 624 c0 492 -3 623 -12 622 -7 -1 -415 -180 -905 -398z" />
      <path d="M3550 2436 c-675 -142 -992 -902 -615 -1471 251 -379 736 -531 1157 -361 228 92 423 282 519 506 63 148 74 204 73 390 0 151 -3 173 -28 255 -103 338 -350 579 -686 670 -87 23 -330 29 -420 11z m42 -653 l138 -137 123 120 c141 140 160 154 205 154 48 0 102 -54 102 -102 0 -45 -14 -64 -154 -205 l-120 -123 137 -138 c119 -121 137 -143 137 -171 0 -68 -42 -110 -109 -111 -44 0 -47 2 -180 134 l-136 135 -136 -135 c-136 -134 -137 -134 -184 -134 -66 0 -105 39 -105 105 0 47 0 48 134 184 l135 136 -135 136 c-132 133 -134 136 -134 180 1 67 42 108 109 109 31 0 49 -14 173 -137z" />
      <path d="M2561 1046 c-1 -275 2 -347 12 -343 92 37 207 92 207 99 0 5 -13 28 -29 51 -78 115 -152 307 -175 455 -13 83 -14 70 -15 -262z" />
    </g>
  </svg>
);
export const TransitSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 46 46"
  >
    <g transform="translate(-2676.297 -55.297)">
      <g transform="translate(2681.292 60.953)">
        <path
          className="b"
          d="M17661.08,2324.238a2.6,2.6,0,0,1-2.6-2.6h-1.248V2307.42h3.945a6.232,6.232,0,0,1,6.232,6.229v6.748a1.247,1.247,0,0,1-1.248,1.246h-2.492a2.59,2.59,0,0,1-2.594,2.6Zm-24.4,0a2.6,2.6,0,0,1-2.6-2.6h-3.84a1.245,1.245,0,0,1-1.246-1.246v-23.151a1.245,1.245,0,0,1,1.246-1.246h7.215v2.662h-6.482v5.067h6.482v5.056l2.748-2.755,3.689-3.7.7-.7,1.6,1.611v-5.056h6.482V2296h.711a1.246,1.246,0,0,1,1.244,1.246v24.4h-15.363a2.6,2.6,0,0,1-2.6,2.6Z"
          transform="translate(-17629 -2291.951)"
        />
        <path
          className="c"
          d="M331.48-333.68H325v1.849h6.48v2.773l3.689-3.7-3.689-3.7Zm5.528-.924v-2.773h6.48v-1.849h-6.48V-342l-3.689,3.7,3.689,3.7Z"
          transform="translate(-321.411 342)"
        />
      </g>
    </g>
  </svg>
);
export const ShipedSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 40 40"
  >
    <g transform="translate(4.085 5.198)">
      <path
        d="M55.914,47.61a3.159,3.159,0,1,0,2.24.927A3.164,3.164,0,0,0,55.914,47.61Zm-.056,4.6a1.492,1.492,0,1,1,1.492-1.492A1.492,1.492,0,0,1,55.858,52.205Z"
        transform="translate(-30.137 -27.201)"
      />
      <path
        d="M11.674,47.61a3.159,3.159,0,1,0,2.24.927A3.164,3.164,0,0,0,11.674,47.61Zm-.056,4.6a1.492,1.492,0,1,1,1.492-1.492A1.492,1.492,0,0,1,11.618,52.205Z"
        transform="translate(-4.862 -27.201)"
      />
      <path
        d="M61.676,31.234l-1.818-3.348a3.429,3.429,0,0,0-3.026-1.8H53v9.392a4.261,4.261,0,0,1,7.176,1.942h1a.776.776,0,0,0,.776-.776V32.362a2.319,2.319,0,0,0-.279-1.127Zm-7.39-1.179v-3h3a1.393,1.393,0,0,1,1.162.626L60,30.038Z"
        transform="translate(-30.28 -14.906)"
      />
      <path
        d="M21.4,16.878V30.994H10.811a4.145,4.145,0,0,0-8,0H1.119a1.119,1.119,0,0,1,0-2.238h.1V15.09H6.036c.094.2.189.4.287.592Q7.716,18.434,9.1,21.2c.094.193.193.386.287.583l1.526,3.125,4.338-8.7.18-.3c.129-.249.266-.514.394-.8h3.8A1.788,1.788,0,0,1,21.4,16.878Z"
        transform="translate(0 -8.621)"
      />
      <path
        d="M20.377,0A3.858,3.858,0,0,0,16.54,3.858,5.573,5.573,0,0,0,17.3,6.306q1.393,2.756,2.782,5.53l.3.6,1.183-2.366,1.6-3.245a6.854,6.854,0,0,0,1.042-3A3.858,3.858,0,0,0,20.377,0Zm0,5.963a2.233,2.233,0,1,1,1.582-.653A2.238,2.238,0,0,1,20.377,5.963Z"
        transform="translate(-9.45 0)"
      />
    </g>
  </svg>
);
export const WaitingSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 40 40"
  >
    <g transform="translate(0 0.473)">
      <g transform="translate(0 5.718)">
        <path
          d="M67.187,46.53a3.353,3.353,0,1,0,2.374.98A3.357,3.357,0,0,0,67.187,46.53Zm-.059,4.877a1.583,1.583,0,1,1,1.583-1.583A1.583,1.583,0,0,1,67.128,51.407Z"
          transform="translate(-34.794 -25.364)"
        />
        <path
          d="M22.977,46.53a3.353,3.353,0,1,0,2.374.98A3.357,3.357,0,0,0,22.977,46.53Zm-.059,4.877a1.6,1.6,0,1,0-.014,0Z"
          transform="translate(-10.695 -25.364)"
        />
        <path
          d="M71.371,26.911A3.666,3.666,0,0,0,68.16,25H64.12V35.008a4.522,4.522,0,0,1,7.61,2.061h1.064a.823.823,0,0,0,.823-.846V31.673a2.506,2.506,0,0,0-.3-1.215Zm-5.914,2.3V26.028h3.184a1.478,1.478,0,0,1,1.233.664l1.647,2.5Z"
          transform="translate(-34.952 -13.628)"
        />
        <path
          d="M31.891,14H20.241A7.833,7.833,0,0,1,12.4,21.838h-.041v6.669h-.1a1.187,1.187,0,0,0-1.187,1.187h0a1.187,1.187,0,0,0,1.187,1.187h1.82a4.4,4.4,0,0,1,8.493,0H33.783V15.9A1.9,1.9,0,0,0,31.891,14Z"
          transform="translate(-6.034 -7.631)"
        />
        <path d="M6.369,0a6.369,6.369,0,1,0,6.369,6.369A6.369,6.369,0,0,0,6.369,0Zm0,11.209A4.836,4.836,0,1,1,9.792,9.792,4.836,4.836,0,0,1,6.369,11.209Z" />
        <path
          d="M16.16,9.529l-2.265.014V7.05H12.23l0,4.167,3.935-.018Z"
          transform="translate(-6.667 -3.843)"
        />
      </g>
    </g>
  </svg>
);
export const PendingSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 46 46"
  >
    <g transform="translate(-2166 -55)">
      <g transform="translate(2171.009 62.141)">
        <path
          className="b"
          d="M10.174,2.5a7.674,7.674,0,1,0,7.674,7.674A7.681,7.681,0,0,0,10.174,2.5Zm3.247,8.53H10.174a.862.862,0,0,1-.856-.856V6.183a.856.856,0,1,1,1.712,0v3.15h2.391a.848.848,0,1,1,0,1.7Z"
          transform="translate(2.422 -2.5)"
        />
        <path
          className="b"
          d="M16162.587,2091.941a2.555,2.555,0,0,1-2.556-2.556h-1.227v-14h3.885a6.13,6.13,0,0,1,6.133,6.134v6.644a1.228,1.228,0,0,1-1.227,1.227h-2.453a2.554,2.554,0,0,1-2.555,2.555Zm-24.022,0a2.554,2.554,0,0,1-2.556-2.556h-3.782a1.227,1.227,0,0,1-1.227-1.227v-22.8a1.227,1.227,0,0,1,1.227-1.227h2.871a9.261,9.261,0,1,0,17,0h2.928a1.227,1.227,0,0,1,1.227,1.227v24.023h-15.129a2.554,2.554,0,0,1-2.556,2.556Z"
          transform="translate(-16131 -2060.15)"
        />
      </g>
    </g>
  </svg>
);
export const DelivredSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 40 40"
  >
    <g transform="translate(2 9.334)">
      <path
        d="M56.309,32.52a3.565,3.565,0,1,0,3.56,3.56,3.565,3.565,0,0,0-3.56-3.56ZM56.247,37.7a1.681,1.681,0,1,1,1.681-1.681A1.681,1.681,0,0,1,56.247,37.7Z"
        transform="translate(-27.266 -16.812)"
      />
      <path
        d="M12.069,32.52a3.565,3.565,0,1,0,3.56,3.56,3.565,3.565,0,0,0-3.56-3.56ZM12,37.7a1.681,1.681,0,1,1,1.681-1.681A1.681,1.681,0,0,1,12,37.7Z"
        transform="translate(-4.394 -16.812)"
      />
      <path
        d="M62.776,16.8l-2.048-3.772A3.864,3.864,0,0,0,57.3,11H53V21.6a4.8,4.8,0,0,1,8.086,2.188h1.14a.874.874,0,0,0,.874-.874v-4.83A2.661,2.661,0,0,0,62.776,16.8Zm-8.327-1.328V12.087H57.83a1.57,1.57,0,0,1,1.314.705l1.744,2.657Z"
        transform="translate(-27.4 -5.687)"
      />
      <path d="M22.1,0H1.367V15.4H1.261a1.261,1.261,0,0,0,0,2.521H3.193a4.671,4.671,0,0,1,9.013,0h11.9V2.014A2.014,2.014,0,0,0,22.1,0ZM11.433,12.273,7.69,8.525,9.056,7.158l2.376,2.381,5.521-5.521,1.367,1.367Z" />
    </g>
  </svg>
);
export const CancledSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 44 44"
  >
    <g transform="translate(0.333 0.334)">
      <g transform="translate(2.944 9.701)">
        <g transform="translate(0 0)">
          <path
            d="M56.681,32.52a3.936,3.936,0,1,0,3.931,3.931,3.936,3.936,0,0,0-3.931-3.931Zm-.069,5.717a1.856,1.856,0,1,1,1.856-1.856A1.856,1.856,0,0,1,56.612,38.237Z"
            transform="translate(-24.612 -15.176)"
          />
          <path
            d="M12.441,32.52a3.936,3.936,0,1,0,3.931,3.931,3.936,3.936,0,0,0-3.931-3.931Zm-.075,5.717a1.856,1.856,0,1,1,1.856-1.856,1.856,1.856,0,0,1-1.856,1.856Z"
            transform="translate(-3.966 -15.176)"
          />
          <path
            d="M63.794,17.4l-2.261-4.165A4.267,4.267,0,0,0,57.747,11H53V22.7a5.3,5.3,0,0,1,8.928,2.416h1.259a.965.965,0,0,0,.965-.965V18.818A2.939,2.939,0,0,0,63.794,17.4ZM54.6,15.933V12.2h3.733a1.733,1.733,0,0,1,1.451.779l1.925,2.933Z"
            transform="translate(-24.734 -5.133)"
          />
          <path d="M3.525,19.787H1.392a1.392,1.392,0,1,1,0-2.784h.117V0H24.4a2.228,2.228,0,0,1,2.219,2.224V19.785H13.477a5.158,5.158,0,0,0-9.952,0ZM15.245,9.8h0l4.284,4.284,1.081-1.081L16.326,8.721l4.285-4.285L19.53,3.355,15.245,7.64,10.96,3.355,9.879,4.436l4.285,4.285L9.879,13.006l1.081,1.081L15.244,9.8Z" />
        </g>
      </g>
    </g>
  </svg>
);
export const PostpondSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 46 46"
  >
    <g transform="translate(-636 -55)">
      <g transform="translate(641.009 62.705)">
        <path
          className="b"
          d="M3.661.26a.681.681,0,0,0-.673.694v.678H2.31A2.06,2.06,0,0,0,.264,3.678v.678H15.245V3.678A2.059,2.059,0,0,0,13.2,1.632h-.678V.954a.682.682,0,1,0-1.363,0v.678H8.436V.954a.682.682,0,1,0-1.363,0v.678H4.35V.954A.681.681,0,0,0,3.661.26ZM.264,5.718v7.489A2.059,2.059,0,0,0,2.31,15.252H13.2a2.058,2.058,0,0,0,2.045-2.045V5.718ZM3.67,8.441a.681.681,0,1,1-.681.681A.681.681,0,0,1,3.67,8.441Zm2.723,0a.681.681,0,1,1-.681.681A.681.681,0,0,1,6.393,8.441Zm2.723,0a.681.681,0,1,1-.681.681A.681.681,0,0,1,9.116,8.441Zm2.723,0a.681.681,0,1,1-.681.681A.681.681,0,0,1,11.839,8.441ZM3.67,11.164a.681.681,0,1,1-.681.681A.681.681,0,0,1,3.67,11.164Zm2.723,0a.681.681,0,1,1-.681.681A.681.681,0,0,1,6.393,11.164Zm2.723,0a.681.681,0,1,1-.681.681A.681.681,0,0,1,9.116,11.164Zm2.723,0a.681.681,0,1,1-.681.681A.681.681,0,0,1,11.839,11.164Z"
          transform="translate(4.863 -0.26)"
        />
        <path
          className="c"
          d="M16353.587,2131.8a2.554,2.554,0,0,1-2.556-2.555h-1.227v-14h3.885a6.127,6.127,0,0,1,6.133,6.133v6.645a1.227,1.227,0,0,1-1.227,1.227h-2.453a2.554,2.554,0,0,1-2.556,2.556Zm-24.022,0a2.554,2.554,0,0,1-2.556-2.556h-3.782a1.227,1.227,0,0,1-1.227-1.227v-22.8a1.227,1.227,0,0,1,1.228-1.227h2.257a3.774,3.774,0,0,0-.032.492v9.528a3.724,3.724,0,0,0,3.721,3.719h10.89a3.723,3.723,0,0,0,3.719-3.719v-9.528a3.772,3.772,0,0,0-.032-.493h2.273a1.228,1.228,0,0,1,1.228,1.227v24.022h-15.129a2.552,2.552,0,0,1-2.556,2.556Z"
          transform="translate(-16322 -2101.071)"
        />
      </g>
    </g>
  </svg>
);
export const ToReturnSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 46 46"
  >
    <g transform="translate(-636 -55)">
      <g transform="translate(641.009 62.705)">
        <path
          className="b"
          d="M3.661.26a.681.681,0,0,0-.673.694v.678H2.31A2.06,2.06,0,0,0,.264,3.678v.678H15.245V3.678A2.059,2.059,0,0,0,13.2,1.632h-.678V.954a.682.682,0,1,0-1.363,0v.678H8.436V.954a.682.682,0,1,0-1.363,0v.678H4.35V.954A.681.681,0,0,0,3.661.26ZM.264,5.718v7.489A2.059,2.059,0,0,0,2.31,15.252H13.2a2.058,2.058,0,0,0,2.045-2.045V5.718ZM3.67,8.441a.681.681,0,1,1-.681.681A.681.681,0,0,1,3.67,8.441Zm2.723,0a.681.681,0,1,1-.681.681A.681.681,0,0,1,6.393,8.441Zm2.723,0a.681.681,0,1,1-.681.681A.681.681,0,0,1,9.116,8.441Zm2.723,0a.681.681,0,1,1-.681.681A.681.681,0,0,1,11.839,8.441ZM3.67,11.164a.681.681,0,1,1-.681.681A.681.681,0,0,1,3.67,11.164Zm2.723,0a.681.681,0,1,1-.681.681A.681.681,0,0,1,6.393,11.164Zm2.723,0a.681.681,0,1,1-.681.681A.681.681,0,0,1,9.116,11.164Zm2.723,0a.681.681,0,1,1-.681.681A.681.681,0,0,1,11.839,11.164Z"
          transform="translate(4.863 -0.26)"
        />
        <path
          className="c"
          d="M16353.587,2131.8a2.554,2.554,0,0,1-2.556-2.555h-1.227v-14h3.885a6.127,6.127,0,0,1,6.133,6.133v6.645a1.227,1.227,0,0,1-1.227,1.227h-2.453a2.554,2.554,0,0,1-2.556,2.556Zm-24.022,0a2.554,2.554,0,0,1-2.556-2.556h-3.782a1.227,1.227,0,0,1-1.227-1.227v-22.8a1.227,1.227,0,0,1,1.228-1.227h2.257a3.774,3.774,0,0,0-.032.492v9.528a3.724,3.724,0,0,0,3.721,3.719h10.89a3.723,3.723,0,0,0,3.719-3.719v-9.528a3.772,3.772,0,0,0-.032-.493h2.273a1.228,1.228,0,0,1,1.228,1.227v24.022h-15.129a2.552,2.552,0,0,1-2.556,2.556Z"
          transform="translate(-16322 -2101.071)"
        />
      </g>
    </g>
  </svg>
);

export const AcceptedSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 44 44"
  >
    <g transform="translate(0.333 0.334)">
      <g transform="translate(2.944 9.701)">
        <g transform="translate(0 0)">
          <path
            d="M56.681,32.52a3.936,3.936,0,1,0,3.931,3.931,3.936,3.936,0,0,0-3.931-3.931Zm-.069,5.717a1.856,1.856,0,1,1,1.856-1.856A1.856,1.856,0,0,1,56.612,38.237Z"
            transform="translate(-24.612 -15.176)"
          />
          <path
            d="M12.441,32.52a3.936,3.936,0,1,0,3.931,3.931,3.936,3.936,0,0,0-3.931-3.931Zm-.075,5.717a1.856,1.856,0,1,1,1.856-1.856,1.856,1.856,0,0,1-1.856,1.856Z"
            transform="translate(-3.966 -15.176)"
          />
          <path
            d="M63.794,17.4l-2.261-4.165A4.267,4.267,0,0,0,57.747,11H53V22.7a5.3,5.3,0,0,1,8.928,2.416h1.259a.965.965,0,0,0,.965-.965V18.818A2.939,2.939,0,0,0,63.794,17.4ZM54.6,15.933V12.2h3.733a1.733,1.733,0,0,1,1.451.779l1.925,2.933Z"
            transform="translate(-24.734 -5.133)"
          />
          <path d="M3.525,19.787H1.392a1.392,1.392,0,1,1,0-2.784h.117V0H24.4a2.228,2.228,0,0,1,2.219,2.224V19.785H13.477a5.158,5.158,0,0,0-9.952,0ZM11.165,4.2h0L8.952,5.476v6.217l5.431,3.135,5.431-3.135V5.476L14.383,2.356,12.175,3.624l5.4,3.128V9.017l-.954.551V7.338L11.165,4.2Zm1.646,6.636a.194.194,0,0,1-.1-.029l-1.441-.832a.612.612,0,0,1-.25-.49c0-.139.06-.229.154-.229a.193.193,0,0,1,.1.029l1.441.832a.612.612,0,0,1,.25.49C12.965,10.75,12.9,10.84,12.811,10.84Z" />
        </g>
      </g>
    </g>
  </svg>
);
export const InHubSvg = (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    width="40"
    height="40"
    viewBox="0 0 95.000000 81.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,81.000000) scale(0.100000,-0.100000)"
      stroke="none"
    >
      <path
        d="M257 761 c-37 -21 -70 -41 -74 -45 -10 -10 37 9 86 34 53 26 57 26
145 -14 42 -19 76 -33 76 -32 0 4 -158 96 -162 96 -2 -1 -33 -18 -71 -39z"
      />
      <path
        d="M23 683 c-18 -7 -19 -593 -1 -611 7 -7 35 -12 63 -12 42 0 52 -4 60
-22 6 -12 17 -26 26 -31 24 -15 68 0 81 28 l11 25 189 0 188 0 0 303 c0 315
-2 327 -42 327 -16 0 -18 -12 -18 -135 l0 -135 -47 -30 c-28 -17 -59 -29 -73
-28 -23 3 -25 7 -28 61 l-3 58 -49 -28 -49 -27 -48 24 c-26 14 -51 26 -55 28
-5 2 -8 -22 -8 -52 0 -41 -4 -58 -15 -62 -20 -8 -70 13 -106 44 l-29 24 0 129
c0 116 -2 129 -17 128 -10 0 -24 -3 -30 -6z"
      />
      <path
        d="M110 551 l0 -120 29 -20 c46 -33 51 -28 51 50 l0 70 70 -37 70 -38
70 38 70 37 0 -70 c0 -79 7 -85 53 -48 l28 22 -3 116 -3 116 -92 -52 c-50 -28
-99 -57 -108 -65 -13 -11 -18 -10 -33 2 -9 8 -44 30 -77 48 -33 18 -75 42 -92
52 l-33 20 0 -121z"
      />
      <path
        d="M700 235 c0 -139 3 -175 13 -175 8 0 20 -11 27 -25 24 -46 88 -45
108 0 9 19 19 25 45 25 51 0 57 13 57 127 0 122 -13 158 -73 197 -34 22 -52
26 -109 26 l-68 0 0 -175z"
      />
    </g>
  </svg>
);

export const UnconfirmedSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 30 30"
  >
    <g transform="translate(-5298 -3746)">
      <path
        className="b"
        d="M249.62-256.21a15.149,15.149,0,0,0,6.59,6.59l2.2-2.2a.994.994,0,0,1,1.02-.24,11.407,11.407,0,0,0,3.57.57,1,1,0,0,1,1,1V-247a1,1,0,0,1-1,1,17,17,0,0,1-17-17,1,1,0,0,1,1-1h3.5a1,1,0,0,1,1,1,11.36,11.36,0,0,0,.57,3.57,1,1,0,0,1-.25,1.02l-2.2,2.2Z"
        transform="translate(5057.563 4016.264)"
      />
      <path
        className="b"
        d="M644-296.473h9.874L648.937-305,644-296.473Zm5.386-1.346h-.9v-.9h.9v.9Zm0-1.8h-.9v-1.8h.9v1.8Z"
        transform="translate(4668.563 4056.736)"
      />
    </g>
  </svg>
);
export const MoreHDotsSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    className="StSvgCl"
    viewBox="0 0 426.667 426.667"
    style={{ transform: "scale(0.7)" }}
  >
    <g>
      <g>
        <circle cx="42.667" cy="213.333" r="42.667" />
      </g>
    </g>
    <g>
      <g>
        <circle cx="213.333" cy="213.333" r="42.667" />
      </g>
    </g>
    <g>
      <g>
        <circle cx="384" cy="213.333" r="42.667" />
      </g>
    </g>
  </svg>
);
export const NotifSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 30 30"
  >
    <path
      d="M533.01-285.99A1.989,1.989,0,0,0,535-284a1.989,1.989,0,0,0,1.99-1.99Zm8.87-4.19V-296a6.873,6.873,0,0,0-5.29-6.69v-.72A1.588,1.588,0,0,0,535-305a1.588,1.588,0,0,0-1.59,1.59v.72a6.873,6.873,0,0,0-5.29,6.69v5.82L526-288.06V-287h18v-1.06l-2.12-2.12Z"
      transform="translate(-520 310)"
    />
  </svg>
);
export const SimpleFlechRightSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    width="40"
    height="40"
    viewBox="0 0 30 30"
  >
    <g transform="translate(-450 -439)">
      <path
        className="b"
        d="M251.59-90.66l4.58-4.59-4.58-4.59,1.41-1.41,6,6-6,6Z"
        transform="translate(210.41 549.25)"
      />
    </g>
  </svg>
);
export const FlechDwnSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 30 30"
  >
    <g transform="translate(-350 -439)">
      <path
        d="M170.41-99,175-94.42,179.59-99,181-97.59l-6,6-6-6Z"
        transform="translate(190 549)"
      />
    </g>
  </svg>
);
export const MoneySvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 25 25"
  >
    <g transform="translate(0 1)">
      <g transform="translate(2.366 3.65)">
        <path
          d="M23.819,44a2.633,2.633,0,0,1-4.694,0H9v9.114H23.94a3.353,3.353,0,0,1,1.849-5.437V44Zm-6.424,7.435a2.878,2.878,0,1,1,2.878-2.878A2.878,2.878,0,0,1,17.395,51.435Z"
          transform="translate(-9 -37.764)"
        />
        <circle cx="2" cy="2" r="2" transform="translate(15.634 11.35)" />
        <ellipse
          cx="2"
          cy="1.5"
          rx="2"
          ry="1.5"
          transform="translate(10.634 3.35)"
        />
        <g transform="translate(2.236)">
          <path
            d="M31.2,23.037h2.878v4.835a3.362,3.362,0,0,1,.419.088l1.259-6.977L19.231,18l-.909,5.037h7.6a2.638,2.638,0,0,1,5.277,0Z"
            transform="translate(-18.322 -18)"
          />
        </g>
      </g>
    </g>
  </svg>
);
export const ShuffleSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 25 25"
  >
    <g transform="translate(-5298 -3796)">
      <path
        d="M1092.492-298.692,1088.175-303,1087-301.825l4.308,4.308,1.183-1.175ZM1095.75-303l1.7,1.7L1087-290.842l1.175,1.175,10.458-10.45,1.7,1.7V-303Zm.275,7.842-1.175,1.175,2.608,2.608-1.708,1.708h4.583v-4.583l-1.7,1.7-2.608-2.608Z"
        transform="translate(4216.833 4104.833)"
      />
    </g>
  </svg>
);
export const MergeSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 30 30"
  >
    <path
      className="b"
      d="M23.343,28.582l-3.775-3.775a1.311,1.311,0,1,0-1.854,1.854L19.255,28.2H13.446l-4.11-3.775A3.127,3.127,0,0,0,7.214,23.6H3.8a1.3,1.3,0,1,0,0,2.591H7.214a.507.507,0,0,1,.357.134l3.44,3.128-3.44,3.172a.548.548,0,0,1-.357.134H3.8a1.3,1.3,0,1,0,0,2.591H7.214a3.127,3.127,0,0,0,2.122-.827l4.133-3.753h5.808l-1.541,1.541a1.3,1.3,0,1,0,1.832,1.854l3.775-3.775a1.3,1.3,0,0,0,.38-.916A1.252,1.252,0,0,0,23.343,28.582Z"
      transform="translate(2.261 -14.929)"
    />
  </svg>
);
export const WarehousesTreeSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 25 25"
  >
    <g transform="translate(3.56 3.718)">
      <path
        className="b"
        d="M6.84,23.644V16.953a.6.6,0,0,1,.6-.6h2.6v2.418h1.567V16.349h2.528a.6.6,0,0,1,.6.6v6.691a.6.6,0,0,1-.6.6H7.45a.6.6,0,0,1-.61-.6Zm12.692-7.3h-2.6a.6.6,0,0,0-.6.6v6.7a.6.6,0,0,0,.6.6H23.62a.6.6,0,0,0,.6-.6V16.953a.6.6,0,0,0-.6-.6H21.092v2.418H19.524ZM12.29,14.776H18.98a.6.6,0,0,0,.6-.6v-6.7a.6.6,0,0,0-.6-.6H16.452V9.288H14.885V6.87H12.29a.6.6,0,0,0-.6.6v6.691a.6.6,0,0,0,.6.61Z"
        transform="translate(-6.84 -6.87)"
      />
    </g>
  </svg>
);
export const AccountSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 19 19"
  >
    <g transform="translate(-4101.356 -3749.356)">
      <path
        d="M132.856-345A7.859,7.859,0,0,0,125-337.144a7.859,7.859,0,0,0,7.856,7.856,7.859,7.859,0,0,0,7.856-7.856A7.859,7.859,0,0,0,132.856-345Zm0,2.357a2.354,2.354,0,0,1,2.357,2.357,2.354,2.354,0,0,1-2.357,2.357,2.354,2.354,0,0,1-2.357-2.357,2.354,2.354,0,0,1,2.357-2.357Zm0,11.155a5.657,5.657,0,0,1-4.714-2.53c.024-1.563,3.142-2.42,4.714-2.42s4.69.856,4.714,2.42a5.657,5.657,0,0,1-4.714,2.53Z"
        transform="translate(3978 4096)"
      />
    </g>
  </svg>
);
export const IdentitySvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 30 30"
  >
    <g transform="translate(-4098 -3746)">
      <path
        className="b"
        d="M14.54,12.84h6.84V10.56H14.54Zm0,3.42H19.1V13.98H14.54ZM4.28,18.54l.271-.814a2.282,2.282,0,0,1,1.143-1.318l.967-.483a1.138,1.138,0,0,0,.6-.743l.178-.7h.008a3.989,3.989,0,0,1-.882-2.492V11.7a2.28,2.28,0,0,1,4.56,0v.285a3.989,3.989,0,0,1-.882,2.492h.009l.177.7a1.138,1.138,0,0,0,.6.743l.967.483a2.282,2.282,0,0,1,1.143,1.318l.271.814ZM22.521,6H4.28A2.282,2.282,0,0,0,2,8.28V18.54a2.282,2.282,0,0,0,2.28,2.28H22.521a2.282,2.282,0,0,0,2.28-2.28V8.28A2.282,2.282,0,0,0,22.521,6Z"
        transform="translate(4100 3748)"
      />
    </g>
  </svg>
);
export const LockSvg = (
  <svg
    viewBox="-64 0 512 512"
    className="StSvgCl"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="m336 192h-16v-64c0-70.59375-57.40625-128-128-128s-128 57.40625-128 128v64h-16c-26.453125 0-48 21.523438-48 48v224c0 26.476562 21.546875 48 48 48h288c26.453125 0 48-21.523438 48-48v-224c0-26.476562-21.546875-48-48-48zm-229.332031-64c0-47.0625 38.269531-85.332031 85.332031-85.332031s85.332031 38.269531 85.332031 85.332031v64h-170.664062zm0 0" />
  </svg>
);
export const LogoutSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 512 512"
  >
    <g transform="matrix(-1 0 0 1 512 0)">
      <g>
        <g>
          <path
            d="M255.15,468.625H63.787c-11.737,0-21.262-9.526-21.262-21.262V64.638c0-11.737,9.526-21.262,21.262-21.262H255.15    c11.758,0,21.262-9.504,21.262-21.262S266.908,0.85,255.15,0.85H63.787C28.619,0.85,0,29.47,0,64.638v382.724    c0,35.168,28.619,63.787,63.787,63.787H255.15c11.758,0,21.262-9.504,21.262-21.262    C276.412,478.129,266.908,468.625,255.15,468.625z"
            fill="#FF4F4F"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M505.664,240.861L376.388,113.286c-8.335-8.25-21.815-8.143-30.065,0.213s-8.165,21.815,0.213,30.065l92.385,91.173    H191.362c-11.758,0-21.262,9.504-21.262,21.262c0,11.758,9.504,21.263,21.262,21.263h247.559l-92.385,91.173    c-8.377,8.25-8.441,21.709-0.213,30.065c4.167,4.21,9.653,6.336,15.139,6.336c5.401,0,10.801-2.041,14.926-6.124l129.276-127.575    c4.04-3.997,6.336-9.441,6.336-15.139C512,250.302,509.725,244.88,505.664,240.861z"
            fill="#FF4F4F"
          />
        </g>
      </g>
    </g>{" "}
  </svg>
);
export const LangSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 16.617 15.716"
  >
    <path
      d="M14.226,39.509v-.7a6.6,6.6,0,0,1-1.081-.921,13.781,13.781,0,0,1-1.982,1.582l-.08.06-.541-.861.08-.04a14.109,14.109,0,0,0,1.9-1.542,10.078,10.078,0,0,1-1.221-2.6l-.02-.1.981-.26.02.1a8.426,8.426,0,0,0,.941,2.1A4.778,4.778,0,0,0,14.386,34H10.3V32.9h2.242v-.6h1.061v.6h2.242V34h-.44a6.033,6.033,0,0,1-1.562,3.143l.38.38v-.5a.654.654,0,0,1,.661-.661H17.83V31.16a.172.172,0,0,0-.16-.16H8.18a.177.177,0,0,0-.18.16v9.49a.179.179,0,0,0,.18.18h6.046V39.509Z"
      transform="translate(-8 -31)"
    />
    <path
      d="M557.661,470h-.02c-.08.36-.18.821-.28,1.181l-.36,1.281h1.341l-.38-1.281C557.861,470.821,557.761,470.36,557.661,470Z"
      transform="translate(-546.009 -461.211)"
    />
    <path
      d="M357.65,325h-9.49a.158.158,0,0,0-.16.16v9.51a.158.158,0,0,0,.16.16h9.49a.158.158,0,0,0,.16-.16v-9.51A.158.158,0,0,0,357.65,325Zm-3.444,7.948-.48-1.562h-1.742l-.42,1.562h-1.421l1.842-6.066h1.8l1.882,6.066Z"
      transform="translate(-341.193 -319.114)"
    />
    <path
      d="M540,42h3.083a1.363,1.363,0,0,1,1.361,1.361v1.522h.641l-.521.981-.521.961-.521-.961-.541-.981h.641V43.361a.538.538,0,0,0-.541-.541H540Z"
      transform="translate(-529.349 -41.78)"
    />
    <path
      d="M39.586,558.845H36.022a1.38,1.38,0,0,1-1.381-1.361v-1.522H34l.541-.981.521-.981.521.981.521.981h-.621v1.522a.538.538,0,0,0,.541.541h3.564Z"
      transform="translate(-33.479 -543.529)"
    />
  </svg>
);
export const FlagFrSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    className="StSvgCl"
  >
    <path
      fill="#41479B"
      d="M38.345,88.273C17.167,88.273,0,105.44,0,126.618v258.759c0,21.177,17.167,38.345,38.345,38.345
	h132.322V88.273H38.345z"
    />
    <rect x="170.67" y="88.277" fill="#F5F5F5" width="170.67" height="335.45" />
    <path
      fill="#FF4B55"
      d="M473.655,88.273H341.333v335.448h132.322c21.177,0,38.345-17.167,38.345-38.345V126.618
	C512,105.44,494.833,88.273,473.655,88.273z"
    />
  </svg>
);
export const FlagArSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    className="StSvgCl"
  >
    <path
      fill="#73AF00"
      d="M38.345,423.724H256V88.276H38.345C17.167,88.276,0,105.443,0,126.621V385.38 C0,406.557,17.167,423.724,38.345,423.724z"
    />
    <path
      fill="#F5F5F5"
      d="M473.655,423.724c21.177,0,38.345-17.167,38.345-38.345V126.621 c0-21.177-17.167-38.345-38.345-38.345H256v335.448H473.655z"
    />
    <g>
      <path
        fill="#FF4B55"
        d="M298.609,223.906l-15.305,20.021l-23.897-7.999c-1.336-0.447-2.473,1.064-1.673,2.223l14.312,20.743 l-14.993,20.256c-0.839,1.132,0.247,2.68,1.598,2.278l24.15-7.202l14.632,20.519c0.818,1.148,2.626,0.593,2.66-0.815l0.613-25.194 l24.035-7.575c1.344-0.424,1.375-2.314,0.046-2.782l-23.77-8.369l0.223-25.201C301.252,223.401,299.464,222.786,298.609,223.906z"
      />
      <path
        fill="#FF4B55"
        d="M271.866,316.63c-33.459,0-60.6-27.142-60.6-60.631c0-33.428,27.142-60.63,60.6-60.63 c12.448,0,23.928,3.829,33.495,10.308c1.465,0.992,3.137-0.932,1.91-2.208c-14.298-14.866-34.535-23.934-56.971-23.168 c-38.548,1.315-70.46,32.222-72.922,70.713c-2.822,44.089,32.089,80.728,75.554,80.728c21.41,0,40.652-8.951,54.393-23.262 c1.214-1.265-0.462-3.16-1.912-2.177C295.836,312.797,284.337,316.63,271.866,316.63z"
      />
    </g>
  </svg>
);
export const FlagEnSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    className="StSvgCl"
  >
    <path
      fill="#41479B"
      d="M473.655,88.276H38.345C17.167,88.276,0,105.443,0,126.621V385.38
   c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345V126.621
   C512,105.443,494.833,88.276,473.655,88.276z"
    />
    <path
      fill="#F5F5F5"
      d="M511.469,120.282c-3.022-18.159-18.797-32.007-37.814-32.007h-9.977l-163.54,107.147V88.276h-88.276
   v107.147L48.322,88.276h-9.977c-19.017,0-34.792,13.847-37.814,32.007l139.778,91.58H0v88.276h140.309L0.531,391.717
   c3.022,18.159,18.797,32.007,37.814,32.007h9.977l163.54-107.147v107.147h88.276V316.577l163.54,107.147h9.977
   c19.017,0,34.792-13.847,37.814-32.007l-139.778-91.58H512v-88.276H371.691L511.469,120.282z"
    />
    <g>
      <polygon
        fill="#FF4B55"
        points="282.483,88.276 229.517,88.276 229.517,229.517 0,229.517 0,282.483 229.517,282.483 
       229.517,423.724 282.483,423.724 282.483,282.483 512,282.483 512,229.517 282.483,229.517 	"
      />
      <path
        fill="#FF4B55"
        d="M24.793,421.252l186.583-121.114h-32.428L9.224,410.31
       C13.377,415.157,18.714,418.955,24.793,421.252z"
      />
      <path
        fill="#FF4B55"
        d="M346.388,300.138H313.96l180.716,117.305c5.057-3.321,9.277-7.807,12.287-13.075L346.388,300.138z"
      />
      <path
        fill="#FF4B55"
        d="M4.049,109.475l157.73,102.387h32.428L15.475,95.842C10.676,99.414,6.749,104.084,4.049,109.475z"
      />
      <path
        fill="#FF4B55"
        d="M332.566,211.862l170.035-110.375c-4.199-4.831-9.578-8.607-15.699-10.86L300.138,211.862H332.566z"
      />
    </g>
  </svg>
);
export const DarkSvg = (
  <svg
    viewBox="0 0 16 16"
    className="StSvgCl"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.292 11.293C13.8105 11.9631 12.16 12.1659 10.5604 11.8743C8.96077 11.5827 7.48797 10.8106 6.33822 9.66085C5.18847 8.5111 4.41636 7.0383 4.12476 5.43866C3.83317 3.83903 4.03593 2.18852 4.70604 0.707031C3.5266 1.24004 2.49407 2.05123 1.69704 3.07099C0.90001 4.09075 0.362268 5.28865 0.129948 6.56192C-0.102372 7.83518 -0.022333 9.1458 0.363198 10.3813C0.748728 11.6169 1.42824 12.7404 2.34344 13.6556C3.25864 14.5708 4.3822 15.2503 5.61773 15.6359C6.85327 16.0214 8.16389 16.1014 9.43715 15.8691C10.7104 15.6368 11.9083 15.0991 12.9281 14.302C13.9478 13.505 14.759 12.4725 15.292 11.293Z" />
  </svg>
);
export const WhiteSvg = (
  <svg
    className="StSvgCl"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0C8.26522 0 8.51957 0.105357 8.70711 0.292893C8.89464 0.48043 9 0.734784 9 1V2C9 2.26522 8.89464 2.51957 8.70711 2.70711C8.51957 2.89464 8.26522 3 8 3C7.73478 3 7.48043 2.89464 7.29289 2.70711C7.10536 2.51957 7 2.26522 7 2V1C7 0.734784 7.10536 0.48043 7.29289 0.292893C7.48043 0.105357 7.73478 0 8 0ZM12 8C12 9.06087 11.5786 10.0783 10.8284 10.8284C10.0783 11.5786 9.06087 12 8 12C6.93913 12 5.92172 11.5786 5.17157 10.8284C4.42143 10.0783 4 9.06087 4 8C4 6.93913 4.42143 5.92172 5.17157 5.17157C5.92172 4.42143 6.93913 4 8 4C9.06087 4 10.0783 4.42143 10.8284 5.17157C11.5786 5.92172 12 6.93913 12 8ZM11.536 12.95L12.243 13.657C12.4316 13.8392 12.6842 13.94 12.9464 13.9377C13.2086 13.9354 13.4594 13.8302 13.6448 13.6448C13.8302 13.4594 13.9354 13.2086 13.9377 12.9464C13.94 12.6842 13.8392 12.4316 13.657 12.243L12.95 11.536C12.7614 11.3538 12.5088 11.253 12.2466 11.2553C11.9844 11.2576 11.7336 11.3628 11.5482 11.5482C11.3628 11.7336 11.2576 11.9844 11.2553 12.2466C11.253 12.5088 11.3538 12.7614 11.536 12.95ZM13.656 2.343C13.8435 2.53053 13.9488 2.78484 13.9488 3.05C13.9488 3.31516 13.8435 3.56947 13.656 3.757L12.95 4.464C12.8578 4.55951 12.7474 4.63569 12.6254 4.6881C12.5034 4.74051 12.3722 4.7681 12.2394 4.76925C12.1066 4.7704 11.9749 4.7451 11.852 4.69482C11.7291 4.64454 11.6175 4.57029 11.5236 4.4764C11.4297 4.3825 11.3555 4.27085 11.3052 4.14795C11.2549 4.02506 11.2296 3.89338 11.2307 3.7606C11.2319 3.62782 11.2595 3.4966 11.3119 3.3746C11.3643 3.25259 11.4405 3.14225 11.536 3.05L12.243 2.343C12.4305 2.15553 12.6848 2.05021 12.95 2.05021C13.2152 2.05021 13.4695 2.15553 13.657 2.343H13.656ZM15 9C15.2652 9 15.5196 8.89464 15.7071 8.70711C15.8946 8.51957 16 8.26522 16 8C16 7.73478 15.8946 7.48043 15.7071 7.29289C15.5196 7.10536 15.2652 7 15 7H14C13.7348 7 13.4804 7.10536 13.2929 7.29289C13.1054 7.48043 13 7.73478 13 8C13 8.26522 13.1054 8.51957 13.2929 8.70711C13.4804 8.89464 13.7348 9 14 9H15ZM8 13C8.26522 13 8.51957 13.1054 8.70711 13.2929C8.89464 13.4804 9 13.7348 9 14V15C9 15.2652 8.89464 15.5196 8.70711 15.7071C8.51957 15.8946 8.26522 16 8 16C7.73478 16 7.48043 15.8946 7.29289 15.7071C7.10536 15.5196 7 15.2652 7 15V14C7 13.7348 7.10536 13.4804 7.29289 13.2929C7.48043 13.1054 7.73478 13 8 13ZM3.05 4.464C3.14284 4.55691 3.25308 4.63062 3.37441 4.68093C3.49574 4.73124 3.6258 4.75716 3.75715 4.7572C3.88849 4.75725 4.01857 4.73142 4.13993 4.6812C4.2613 4.63098 4.37159 4.55734 4.4645 4.4645C4.55741 4.37166 4.63112 4.26142 4.68143 4.14009C4.73174 4.01876 4.75766 3.8887 4.7577 3.75735C4.75775 3.62601 4.73192 3.49593 4.6817 3.37457C4.63148 3.2532 4.55784 3.14291 4.465 3.05L3.757 2.343C3.5684 2.16084 3.3158 2.06005 3.0536 2.06233C2.7914 2.0646 2.54059 2.16977 2.35518 2.35518C2.16977 2.54059 2.0646 2.7914 2.06233 3.0536C2.06005 3.3158 2.16084 3.5684 2.343 3.757L3.05 4.464ZM4.464 12.95L3.757 13.657C3.5684 13.8392 3.3158 13.94 3.0536 13.9377C2.7914 13.9354 2.54059 13.8302 2.35518 13.6448C2.16977 13.4594 2.0646 13.2086 2.06233 12.9464C2.06005 12.6842 2.16084 12.4316 2.343 12.243L3.05 11.536C3.2386 11.3538 3.4912 11.253 3.7534 11.2553C4.0156 11.2576 4.26641 11.3628 4.45182 11.5482C4.63723 11.7336 4.7424 11.9844 4.74467 12.2466C4.74695 12.5088 4.64616 12.7614 4.464 12.95ZM2 9C2.26522 9 2.51957 8.89464 2.70711 8.70711C2.89464 8.51957 3 8.26522 3 8C3 7.73478 2.89464 7.48043 2.70711 7.29289C2.51957 7.10536 2.26522 7 2 7H1C0.734784 7 0.48043 7.10536 0.292893 7.29289C0.105357 7.48043 0 7.73478 0 8C0 8.26522 0.105357 8.51957 0.292893 8.70711C0.48043 8.89464 0.734784 9 1 9H2Z"
    />
  </svg>
);
export const ChangeAc = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 381.669 381.669"
  >
    <g>
      <polygon points="106.615,127.135 211.979,127.135 211.979,68.462 106.615,68.462 106.615,28.398 0,97.799 106.615,167.2 	" />
      <path
        d="M302.485,163.374c36.158,0,65.575-29.417,65.575-65.575s-29.417-65.575-65.575-65.575S236.91,61.641,236.91,97.799
		S266.327,163.374,302.485,163.374z"
      />
      <polygon
        points="381.669,283.87 275.054,214.469 275.054,254.534 169.69,254.534 169.69,313.207 275.054,313.207 275.054,353.271 	
		"
      />
      <path
        d="M79.184,218.295c-36.158,0-65.575,29.417-65.575,65.575s29.417,65.575,65.575,65.575s65.575-29.417,65.575-65.575
		S115.342,218.295,79.184,218.295z"
      />
    </g>
  </svg>
);
export const CheckSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl2"
    viewBox="0 0 329.954 329.954"
  >
    <path
      id="XMLID_89_"
      d="M99.85,299.045c2.813,2.813,6.629,4.393,10.607,4.393c3.979,0,7.794-1.581,10.606-4.393L325.56,94.548 c2.814-2.813,4.394-6.628,4.394-10.606c0-3.979-1.58-7.794-4.394-10.607l-42.427-42.426c-5.857-5.857-15.355-5.858-21.213,0 L110.461,182.37l-42.428-42.428c-2.813-2.813-6.629-4.394-10.607-4.394s-7.793,1.581-10.606,4.394L4.393,182.369 c-5.857,5.858-5.857,15.355,0,21.213L99.85,299.045z"
    />
  </svg>
);
export const CheckSvg2 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
  >
    <g id="ic_done" transform="translate(-4548 -3746)">
      <rect
        id="Base"
        width="40"
        height="40"
        transform="translate(4548 3746)"
        fill="none"
      />
      <path
        id="Icon"
        d="M494.782-323.49l-6.586-7.334-2.2,2.445,8.782,9.779L513.6-339.555,511.4-342l-16.623,18.51Z"
        transform="translate(4068.001 4096)"
        fill="#d9d9d9"
        stroke="#d9d9d9"
        strokeWidth="1"
        fillRule="evenodd"
      />
    </g>
  </svg>
);
export const OutSvg = (
  <svg
    viewBox="0 0 365.696 365.696"
    className="StSvgCl2"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="m243.1875 182.859375 113.132812-113.132813c12.5-12.5 12.5-32.765624 0-45.246093l-15.082031-15.082031c-12.503906-12.503907-32.769531-12.503907-45.25 0l-113.128906 113.128906-113.132813-113.152344c-12.5-12.5-32.765624-12.5-45.246093 0l-15.105469 15.082031c-12.5 12.503907-12.5 32.769531 0 45.25l113.152344 113.152344-113.128906 113.128906c-12.503907 12.503907-12.503907 32.769531 0 45.25l15.082031 15.082031c12.5 12.5 32.765625 12.5 45.246093 0l113.132813-113.132812 113.128906 113.132812c12.503907 12.5 32.769531 12.5 45.25 0l15.082031-15.082031c12.5-12.503906 12.5-32.769531 0-45.25zm0 0" />
  </svg>
);
export const DoneSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 30 30"
  >
    <g transform="translate(-4548 -3746)">
      <path
        d="M491.6-331.4l-4.2-4.2-1.4,1.4,5.6,5.6,12-12-1.4-1.4-10.6,10.6Z"
        transform="translate(4068.001 4096)"
      />
    </g>
  </svg>
);
export const FlechSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 512.008 512.008"
  >
    <g transform="matrix(-1 0 0 1 512.008 0)">
      <g>
        <g>
          <path d="M508.885,248.468L306.219,45.801c-21.803-21.803-57.28-21.803-79.083,0s-21.803,57.28,0,79.083l77.781,77.781H53.333    C23.936,202.665,0,226.601,0,255.999s23.936,53.333,53.333,53.333h251.584l-77.781,77.781c-21.803,21.803-21.803,57.28,0,79.083    c10.901,10.901,25.216,16.363,39.552,16.363s28.629-5.44,39.552-16.363l202.667-202.667    C513.045,259.369,513.045,252.628,508.885,248.468z" />
        </g>
      </g>
    </g>{" "}
  </svg>
);
export const NextSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 512.002 512.002"
  >
    <path d="M388.425,241.951L151.609,5.79c-7.759-7.733-20.321-7.72-28.067,0.04c-7.74,7.759-7.72,20.328,0.04,28.067l222.72,222.105 L123.574,478.106c-7.759,7.74-7.779,20.301-0.04,28.061c3.883,3.89,8.97,5.835,14.057,5.835c5.074,0,10.141-1.932,14.017-5.795 l236.817-236.155c3.737-3.718,5.834-8.778,5.834-14.05S392.156,245.676,388.425,241.951z" />
  </svg>
);
export const PrevSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 512.002 512.002"
  >
    <g transform="matrix(-1 0 0 1 512.002 0)">
      <path d="M388.425,241.951L151.609,5.79c-7.759-7.733-20.321-7.72-28.067,0.04c-7.74,7.759-7.72,20.328,0.04,28.067l222.72,222.105    L123.574,478.106c-7.759,7.74-7.779,20.301-0.04,28.061c3.883,3.89,8.97,5.835,14.057,5.835c5.074,0,10.141-1.932,14.017-5.795    l236.817-236.155c3.737-3.718,5.834-8.778,5.834-14.05S392.156,245.676,388.425,241.951z" />
    </g>
  </svg>
);
export const ResetSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 512 512"
  >
    <g>
      <g>
        <path
          d="M478.213,163.264l-46.805-80.939c-5.099-9.344-16.107-14.229-27.648-9.963l-52.885,21.248
			c-10.048-7.232-20.608-13.376-31.531-18.304L311.301,19.2C309.936,8.256,300.443,0,289.221,0h-93.867
			c-11.221,0-20.715,8.256-22.059,19.008l-8.064,56.277c-10.581,4.8-20.971,10.859-31.467,18.325L80.731,72.299
			c-10.197-3.925-22.357,0.491-27.435,9.771L6.405,163.157c-5.632,9.557-3.307,21.952,5.44,28.864l44.821,35.029
			c-0.704,6.763-1.045,12.672-1.045,18.283s0.341,11.52,1.024,18.283l-44.843,35.051c-8.555,6.763-10.901,18.752-5.44,28.736
			l46.805,80.96c5.099,9.323,16.128,14.208,27.669,9.941l52.885-21.248c10.048,7.232,20.608,13.376,31.531,18.304l8.043,56.085
			c1.344,10.965,10.837,19.221,22.059,19.221h73.515c3.989,0,7.616-2.219,9.451-5.739c1.835-3.52,1.557-7.765-0.704-11.029
			c-16.32-23.381-24.96-50.795-24.96-79.232c0-13.269,1.941-26.56,5.781-39.509c0.981-3.328,0.299-6.912-1.856-9.643
			c-2.155-2.709-5.461-4.16-8.939-4.053c-1.152,0.064-2.283,0.213-5.184,0.576c-53.056,0-96.213-43.157-96.213-96.213
			c0-53.056,43.157-96.235,96.213-96.235c53.056,0,96.213,43.157,96.021,97.984c-0.149,1.131-0.299,2.261-0.363,3.413
			c-0.171,3.477,1.344,6.805,4.053,8.939c2.731,2.155,6.336,2.795,9.643,1.856c20.757-6.187,41.216-7.659,64.384-3.456
			c2.837,0.512,5.952-0.768,8.341-2.539c2.368-1.771,3.947-5.056,4.267-8c0.043-0.384,0.149-2.112,0.149-2.496
			c0-6.635-0.469-12.885-1.024-18.283L472.752,192C481.307,185.259,483.653,173.269,478.213,163.264z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M497.989,298.667c-5.888,0-10.667,4.779-10.667,10.667v26.027c-16.085-28.309-48.213-58.027-96-58.027
			c-64.704,0-117.333,52.629-117.333,117.333S326.619,512,391.323,512c5.888,0,10.667-4.779,10.667-10.667
			c0-5.888-4.779-10.667-10.667-10.667c-52.928,0-96-43.072-96-96s43.072-96,96-96c50.304,0,77.973,41.557,84.779,64h-42.112
			c-5.888,0-10.667,4.779-10.667,10.667c0,5.888,4.779,10.667,10.667,10.667h64c5.888,0,10.667-4.779,10.667-10.667v-64
			C508.656,303.445,503.899,298.667,497.989,298.667z"
        />
      </g>
    </g>
  </svg>
);
export const FilterSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 21.001 24"
  >
    <defs>
      <style>
        {
          ".a{fill:none;stroke:var(--fntClr);stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:1.5px;}"
        }
      </style>
    </defs>
    <g transform="translate(0.75 0.75)">
      <ellipse className="a" cx="9.75" cy="4.5" rx="9.75" ry="4.5" />
      <path
        className="a"
        d="M0,0A9.747,9.747,0,0,0,7.5,9.479V15.75a2.25,2.25,0,0,0,4.5,0V9.479A9.747,9.747,0,0,0,19.5,0"
        transform="translate(0 4.5)"
      />
    </g>
  </svg>
);
export const BankSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 27.79 28.925"
  >
    <g transform="translate(3.352 10.825)">
      <path
        d="M20.641,40.011a.481.481,0,0,0,.488-.488V38.488A.481.481,0,0,0,20.641,38H15.888a.481.481,0,0,0-.488.488v1.036a.481.481,0,0,0,.488.488h.792V47.69h-.792a.481.481,0,0,0-.488.488v1.036a.481.481,0,0,0,.488.488h4.754a.481.481,0,0,0,.488-.488V48.177a.481.481,0,0,0-.488-.488h-.792V40.011Z"
        transform="translate(-15.4 -38)"
      />
    </g>
    <g transform="translate(11.031 10.825)">
      <path
        d="M45.841,40.011a.481.481,0,0,0,.488-.488V38.488A.481.481,0,0,0,45.841,38H41.088a.481.481,0,0,0-.488.488v1.036a.481.481,0,0,0,.488.488h.792V47.69h-.792a.481.481,0,0,0-.488.488v1.036a.481.481,0,0,0,.488.488h4.754a.481.481,0,0,0,.488-.488V48.177a.481.481,0,0,0-.488-.488h-.792V40.011Z"
        transform="translate(-40.6 -38)"
      />
    </g>
    <g transform="translate(18.709 10.825)">
      <path
        d="M71.041,40.011a.481.481,0,0,0,.488-.488V38.488A.481.481,0,0,0,71.041,38H66.288a.481.481,0,0,0-.488.488v1.036a.481.481,0,0,0,.488.488h.792V47.69h-.792a.481.481,0,0,0-.488.488v1.036a.481.481,0,0,0,.488.488h4.754a.481.481,0,0,0,.488-.488V48.177a.481.481,0,0,0-.488-.488h-.792V40.011Z"
        transform="translate(-65.8 -38)"
      />
    </g>
    <g transform="translate(0 23.928)">
      <path
        d="M31.519,82.585h-.64V81.67a.676.676,0,0,0-.67-.67H6.381a.676.676,0,0,0-.67.67v.914H5.07a.676.676,0,0,0-.67.67v2.072a.676.676,0,0,0,.67.67H31.519a.676.676,0,0,0,.67-.67V83.255A.676.676,0,0,0,31.519,82.585Z"
        transform="translate(-4.4 -81)"
      />
    </g>
    <g transform="translate(0.488)">
      <path
        d="M6.67,11.929H32.144a.676.676,0,0,0,.67-.67V9.674a.732.732,0,0,0-.366-.609L19.712,2.544a.711.711,0,0,0-.609,0L6.366,9.064A.67.67,0,0,0,6,9.674v1.585A.676.676,0,0,0,6.67,11.929Z"
        transform="translate(-6 -2.475)"
      />
    </g>
  </svg>
);
export const ReaperSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 25 25"
  >
    <g transform="translate(-5248 -3796)">
      <path
        d="M1049.244-300.917h8.111v2.45l3.245-3.267L1057.355-305v2.45h-9.733v4.9h1.622v-3.267Zm8.111,8.167h-8.111v-2.45L1046-291.933l3.244,3.267v-2.45h9.733v-4.9h-1.622v3.267Z"
        transform="translate(4207.2 4105.333)"
      />
    </g>
  </svg>
);
export const InLinkSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 30 30"
  >
    <g transform="translate(-250 -389)">
      <path
        d="M86.9-135a3.1,3.1,0,0,1,3.1-3.1h4V-140H90a5,5,0,0,0-5,5,5,5,0,0,0,5,5h4v-1.9H90a3.1,3.1,0,0,1-3.1-3.1Zm4.1,1h8v-2H91v2Zm9-6H96v1.9h4a3.1,3.1,0,0,1,3.1,3.1,3.1,3.1,0,0,1-3.1,3.1H96v1.9h4a5,5,0,0,0,5-5,5,5,0,0,0-5-5Z"
        transform="translate(170 539)"
      />
    </g>
  </svg>
);
export const CloseSvg = (
  <svg
    viewBox="0 0 329.26933 329"
    className="StSvgCl"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0" />
  </svg>
);
export const PlayListAddSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={{ transform: "scale(.75)" }}
    className="StSvgCl"
    viewBox="0 0 30.000000 30.000000"
  >
    <g
      transform="translate(0.000000,30.000000) scale(0.100000,-0.100000)"
      stroke="none"
    >
      <path d="M129 232 c-13 -11 -36 -22 -51 -26 -16 -3 -28 -10 -28 -15 0 -4 -11 -20 -25 -35 -30 -33 -32 -59 -5 -86 18 -18 33 -20 130 -20 97 0 112 2 130 20 25 25 25 55 0 80 -11 11 -20 27 -20 35 0 9 -11 27 -25 40 -29 30 -73 32 -106 7z m31 -82 c0 -22 4 -28 15 -24 21 9 19 -10 -5 -31 -19 -17 -21 -17 -40 0 -24 21 -26 40 -5 31 11 -4 15 2 15 24 0 17 5 30 10 30 6 0 10 -13 10 -30z" />
    </g>
  </svg>
);
export const FileUpSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 30 30"
  >
    <path
      className="b"
      d="M937-298H925v2h12v-2Zm0-4H925v2h12v-2Zm4,8v-4h-2v4h-4v2h4v4h2v-4h4v-2Zm-16,2h8v-2h-8v2Z"
      transform="translate(-919 310)"
    />
  </svg>
);
export const FileDownSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 25 25"
  >
    <g transform="translate(-1450 -389)">
      <path
        d="M1059.792-137.946h-3.369V-143h-5.054v5.054H1048l5.9,5.9,5.9-5.9ZM1048-130.366v1.685h11.792v-1.685Z"
        transform="translate(408.738 537.896)"
      />
    </g>
  </svg>
);
export const ExcelSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 25 25"
  >
    <g transform="translate(-1450 -389)">
      <g transform="translate(-3487 968)">
        <path
          d="M27.758,35.763V22.41H26.68c-2.769.5-5.531.963-8.31,1.443v12.63c2.734.483,5.5.966,8.255,1.466H27.75V35.763Zm-4.072-2.772a21.3,21.3,0,0,1-.906-2.266c-.25.733-.6,1.423-.878,2.141-.4,0-.79-.023-1.186-.038.463-.908.911-1.824,1.388-2.724-.405-.931-.853-1.841-1.271-2.764l1.2-.068c.268.705.563,1.4.785,2.126.25-.768.593-1.5.9-2.231q.613-.043,1.228-.075-.72,1.481-1.453,2.969c.5,1,1,2.014,1.5,3.024C24.554,33.051,24.121,33.024,23.686,32.991Z"
          transform="translate(4923 -596.41)"
        />
        <path
          d="M57.72,29.33v.958h1.914V31.7H57.72v.775h1.914V33.89H57.72v.775h1.914v1.411H57.72v.775h1.914v1.4H57.72v.82h1.914v1.368H57.72V41.4h6.609V29.33Zm5.151,11.121H60.089V39.083h2.782Zm0-2.189H60.089V36.849h2.782Zm0-2.189H60.089V34.663h2.782Zm0-2.189H60.089V32.474h2.782Zm0-2.189H60.089V30.288h2.782Z"
          transform="translate(4893.493 -601.599)"
        />
      </g>
    </g>
  </svg>
);

export const ExpressSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 40 40"
  >
    <g transform="translate(-4248 -3846)">
      <g transform="translate(4246.914 3840.131)">
        <path
          d="M42.129,12A14.118,14.118,0,0,0,32.09,16.2h0a1.243,1.243,0,0,0,0,1.761l2.1,2.1a1.266,1.266,0,0,0,1.8,0,1.243,1.243,0,0,0,0-1.761l-1.161-1.161a11.47,11.47,0,0,1,6.106-2.51V16.27a1.236,1.236,0,1,0,2.472,0V14.622a11.873,11.873,0,0,1,6.106,2.547l-1.2,1.124a1.243,1.243,0,0,0,0,1.761,1.266,1.266,0,0,0,1.8,0l1.161-1.161A11.615,11.615,0,0,1,53.816,25H52.168a1.236,1.236,0,0,0,0,2.472h1.648a11.621,11.621,0,0,1-2.547,6.068l-1.161-1.161a1.245,1.245,0,0,0-1.761,1.761L49.509,35.3A11.615,11.615,0,0,1,43.4,37.884V36.236a1.236,1.236,0,1,0-2.472,0v1.648a11.773,11.773,0,0,1-6.106-2.51l1.161-1.161a1.245,1.245,0,1,0-1.761-1.761l-2.1,2.1h0a.97.97,0,0,0-.262.412,1.288,1.288,0,0,0,.262,1.349h0a14.086,14.086,0,0,0,10,4.158,14.234,14.234,0,0,0,0-28.469Z"
          transform="translate(-18.278)"
        />
        <path
          d="M57.436,31.1A1.247,1.247,0,0,0,56.2,32.336V38.18a1.247,1.247,0,0,0,1.236,1.236h4.982a1.236,1.236,0,1,0,0-2.472H58.71V32.336A1.255,1.255,0,0,0,57.436,31.1Z"
          transform="translate(-33.585 -11.945)"
        />
        <path
          d="M12.052,46.7H3.736a1.236,1.236,0,1,0,0,2.472h8.316a1.236,1.236,0,1,0,0-2.472Z"
          transform="translate(0 -21.702)"
        />
        <path
          d="M16.805,33.9H11.336a1.236,1.236,0,1,0,0,2.472h5.469a1.236,1.236,0,1,0,0-2.472Z"
          transform="translate(-4.753 -13.697)"
        />
        <path
          d="M16.805,59.4H11.336a1.236,1.236,0,1,0,0,2.472h5.469a1.236,1.236,0,1,0,0-2.472Z"
          transform="translate(-4.753 -29.645)"
        />
      </g>
    </g>
  </svg>
);
export const CalnderSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 40 40"
  >
    <g transform="translate(-4298 -3796)">
      <path
        d="M307.333-302.333H306V-305h-2.667v2.667H292.667V-305H290v2.667h-1.333a2.655,2.655,0,0,0-2.653,2.667L286-281a2.666,2.666,0,0,0,2.667,2.667h18.667A2.675,2.675,0,0,0,310-281v-18.667a2.674,2.674,0,0,0-2.667-2.667Zm0,21.333H288.667v-14.667h18.667V-281Zm-16-12H298v6.667h-6.667Z"
        transform="translate(4020 4107.667)"
      />
    </g>
  </svg>
);

export const RplySvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 30 30"
  >
    <path
      d="M173-218v-4l-7,7,7,7v-4.1c5,0,8.5,1.6,11,5.1C183-212,180-217,173-218Z"
      transform="translate(-160 230)"
    />
  </svg>
);
export const FacebookSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 30 30"
  >
    <g transform="translate(-1500 -489)">
      <path
        d="M1096.842-46v-8.211h2.656l.395-3.2h-3.051v-2.044c0-.925.247-1.557,1.525-1.557H1100v-2.864a20.4,20.4,0,0,0-2.375-.125c-2.356,0-3.962,1.495-3.962,4.234V-57.4H1091v3.2h2.663V-46Z"
        transform="translate(420 559)"
      />
    </g>
  </svg>
);
export const LoadingSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
  >
    <circle
      cx="50"
      cy="50"
      r="30"
      stroke="#b6b6b6"
      strokeWidth="10"
      fill="none"
    ></circle>
    <circle
      cx="50"
      cy="50"
      r="30"
      stroke="#3498db"
      strokeWidth="8"
      strokeLinecap="round"
      fill="none"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        repeatCount="indefinite"
        dur="1s"
        values="0 50 50;180 50 50;720 50 50"
        keyTimes="0;0.5;1"
      ></animateTransform>
      <animate
        attributeName="stroke-dasharray"
        repeatCount="indefinite"
        dur="1s"
        values="18.84955592153876 169.64600329384882;94.2477796076938 94.24777960769377;18.84955592153876 169.64600329384882"
        keyTimes="0;0.5;1"
      ></animate>
    </circle>
  </svg>
);

export const LoadingSmallSvg = <div className="loader-spinner" />;

export const RefreshSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 30 30"
  >
    <g transform="translate(-500 -489)">
      <path
        className="refreshCb"
        d="M300.64-60.65A7.958,7.958,0,0,0,294.99-63,7.989,7.989,0,0,0,287-55a7.989,7.989,0,0,0,7.99,8,7.983,7.983,0,0,0,7.73-6h-2.08a5.991,5.991,0,0,1-5.65,4,6,6,0,0,1-6-6,6,6,0,0,1,6-6,5.915,5.915,0,0,1,4.22,1.78L295.99-56h7v-7l-2.35,2.35Z"
        transform="translate(220 559)"
      />
    </g>
  </svg>
);
export const MoreHSvg = (
  <svg
    className="StSvgCl"
    xmlns="http://www.w3.org/2000/svg"
    style={{ transform: "scale(.75)" }}
    viewBox="0 0 24 24"
  >
    <path d="M19.355,10.036C18.674,6.595,15.641,4,12,4C9.108,4,6.603,5.639,5.352,8.036C2.343,8.36,0,10.906,0,14c0,3.314,2.686,6,6,6 h13c2.761,0,5-2.239,5-5C24,12.36,21.948,10.221,19.355,10.036z M12,8l5,5h-3v4h-4v-4H7L12,8z" />
  </svg>
);
export const CntrlSid = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="StSvgCl"
    viewBox="0 0 24 24"
  >
    <path
      d="M8,12H0V10H8v2Zm8-5H0V5H16V7Zm0-5H8V0h8V2Z"
      transform="translate(4 6)"
    />
  </svg>
);
export const SerchSVg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-1 0 136 136.21852"
    style={{ height: "16px" }}
    className="StSvgCl"
  >
    <g id="surface1">
      <path d="M 93.148438 80.832031 C 109.5 57.742188 104.03125 25.769531 80.941406 9.421875 C 57.851562 -6.925781 25.878906 -1.460938 9.53125 21.632812 C -6.816406 44.722656 -1.351562 76.691406 21.742188 93.039062 C 38.222656 104.707031 60.011719 105.605469 77.394531 95.339844 L 115.164062 132.882812 C 119.242188 137.175781 126.027344 137.347656 130.320312 133.269531 C 134.613281 129.195312 134.785156 122.410156 130.710938 118.117188 C 130.582031 117.980469 130.457031 117.855469 130.320312 117.726562 Z M 51.308594 84.332031 C 33.0625 84.335938 18.269531 69.554688 18.257812 51.308594 C 18.253906 33.0625 33.035156 18.269531 51.285156 18.261719 C 69.507812 18.253906 84.292969 33.011719 84.328125 51.234375 C 84.359375 69.484375 69.585938 84.300781 51.332031 84.332031 C 51.324219 84.332031 51.320312 84.332031 51.308594 84.332031 Z M 51.308594 84.332031 " />
    </g>
  </svg>
);
export const DotSVg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 22"
    style={{ height: "22px" }}
  >
    <g transform="translate(-4898 -3846)">
      <path
        className="b"
        d="M771-253a6,6,0,0,0,6-6,6,6,0,0,0-6-6,6,6,0,0,0-6,6A6,6,0,0,0,771-253Z"
        transform="translate(4138 4116)"
      />
    </g>
  </svg>
);

export const CategoriesIcons = {
  Payements: (
    <div
      className="InFlx AlgnItm JstfCnt Bdg_Brn"
      style={{ width: "40px", height: "40px", borderRadius: "50%" }}
    >
      {MoneySvg}
    </div>
  ),
  Alert: (
    <div
      className="InFlx AlgnItm JstfCnt Bdg_Brn"
      style={{
        width: "40px",
        height: "40px",
        borderRadius: "50%",
        backgroundColor: "#df5718",
      }}
    >
      {WarningSvg}
    </div>
  ),
  LowStock: (
    <div
      className="InFlx AlgnItm JstfCnt"
      style={{
        width: "40px",
        height: "40px",
        borderRadius: "50%",
        backgroundColor: "#E74C3C",
      }}
    >
      {PackageSvg}
    </div>
  ),
};
export const SocialMediaIcons = {
  sm: {
    Facebook: (
      <svg
        className="StSvgCl"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
        width="60px"
        height="60px"
      >
        {" "}
        <path d="M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h10v-9h-3v-3h3v-1.611C16,9.339,17.486,8,20.021,8 c1.214,0,1.856,0.09,2.16,0.131V11h-1.729C19.376,11,19,11.568,19,12.718V14h3.154l-0.428,3H19v9h5c1.105,0,2-0.895,2-2V6 C26,4.895,25.104,4,24,4z" />
      </svg>
    ),
    Instagram: (
      <svg
        className="StSvgCl"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
        width="60px"
        height="60px"
      >
        {" "}
        <path d="M 9.9980469 3 C 6.1390469 3 3 6.1419531 3 10.001953 L 3 20.001953 C 3 23.860953 6.1419531 27 10.001953 27 L 20.001953 27 C 23.860953 27 27 23.858047 27 19.998047 L 27 9.9980469 C 27 6.1390469 23.858047 3 19.998047 3 L 9.9980469 3 z M 22 7 C 22.552 7 23 7.448 23 8 C 23 8.552 22.552 9 22 9 C 21.448 9 21 8.552 21 8 C 21 7.448 21.448 7 22 7 z M 15 9 C 18.309 9 21 11.691 21 15 C 21 18.309 18.309 21 15 21 C 11.691 21 9 18.309 9 15 C 9 11.691 11.691 9 15 9 z M 15 11 A 4 4 0 0 0 11 15 A 4 4 0 0 0 15 19 A 4 4 0 0 0 19 15 A 4 4 0 0 0 15 11 z" />
      </svg>
    ),
    TikTok: (
      <svg
        className="StSvgCl"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
        width="60px"
        height="60px"
      >
        {" "}
        <path d="M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h18c1.105,0,2-0.895,2-2V6C26,4.895,25.104,4,24,4z M22.689,13.474 c-0.13,0.012-0.261,0.02-0.393,0.02c-1.495,0-2.809-0.768-3.574-1.931c0,3.049,0,6.519,0,6.577c0,2.685-2.177,4.861-4.861,4.861 C11.177,23,9,20.823,9,18.139c0-2.685,2.177-4.861,4.861-4.861c0.102,0,0.201,0.009,0.3,0.015v2.396c-0.1-0.012-0.197-0.03-0.3-0.03 c-1.37,0-2.481,1.111-2.481,2.481s1.11,2.481,2.481,2.481c1.371,0,2.581-1.08,2.581-2.45c0-0.055,0.024-11.17,0.024-11.17h2.289 c0.215,2.047,1.868,3.663,3.934,3.811V13.474z" />
      </svg>
    ),
  },
  md: {
    Facebook: (
      <svg
        fill="var(--fntClr)"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
        width="60px"
        height="60px"
      >
        {" "}
        <path d="M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h10v-9h-3v-3h3v-1.611C16,9.339,17.486,8,20.021,8 c1.214,0,1.856,0.09,2.16,0.131V11h-1.729C19.376,11,19,11.568,19,12.718V14h3.154l-0.428,3H19v9h5c1.105,0,2-0.895,2-2V6 C26,4.895,25.104,4,24,4z" />
      </svg>
    ),
    Instagram: (
      <svg
        fill="var(--fntClr)"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
        width="60px"
        height="60px"
      >
        {" "}
        <path d="M 9.9980469 3 C 6.1390469 3 3 6.1419531 3 10.001953 L 3 20.001953 C 3 23.860953 6.1419531 27 10.001953 27 L 20.001953 27 C 23.860953 27 27 23.858047 27 19.998047 L 27 9.9980469 C 27 6.1390469 23.858047 3 19.998047 3 L 9.9980469 3 z M 22 7 C 22.552 7 23 7.448 23 8 C 23 8.552 22.552 9 22 9 C 21.448 9 21 8.552 21 8 C 21 7.448 21.448 7 22 7 z M 15 9 C 18.309 9 21 11.691 21 15 C 21 18.309 18.309 21 15 21 C 11.691 21 9 18.309 9 15 C 9 11.691 11.691 9 15 9 z M 15 11 A 4 4 0 0 0 11 15 A 4 4 0 0 0 15 19 A 4 4 0 0 0 19 15 A 4 4 0 0 0 15 11 z" />
      </svg>
    ),
    TikTok: (
      <svg
        fill="var(--fntClr)"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
        width="60px"
        height="60px"
      >
        {" "}
        <path d="M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h18c1.105,0,2-0.895,2-2V6C26,4.895,25.104,4,24,4z M22.689,13.474 c-0.13,0.012-0.261,0.02-0.393,0.02c-1.495,0-2.809-0.768-3.574-1.931c0,3.049,0,6.519,0,6.577c0,2.685-2.177,4.861-4.861,4.861 C11.177,23,9,20.823,9,18.139c0-2.685,2.177-4.861,4.861-4.861c0.102,0,0.201,0.009,0.3,0.015v2.396c-0.1-0.012-0.197-0.03-0.3-0.03 c-1.37,0-2.481,1.111-2.481,2.481s1.11,2.481,2.481,2.481c1.371,0,2.581-1.08,2.581-2.45c0-0.055,0.024-11.17,0.024-11.17h2.289 c0.215,2.047,1.868,3.663,3.934,3.811V13.474z" />
      </svg>
    ),
  },
};

export const ShopSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
  >
    <g id="Dev" transform="translate(-4098 -3746)">
      <rect
        id="Base"
        width="30"
        height="30"
        transform="translate(4098 3746)"
        fill="none"
      />
      <path
        id="Store"
        d="M34.019,14.053l1.876,4.818a3.664,3.664,0,0,1,.556,1.927,3.575,3.575,0,0,1-.471,1.784V32.2a.591.591,0,0,1-.591.591h-17.6A.593.593,0,0,1,17.2,32.2V22.581a3.634,3.634,0,0,1,.089-3.714L19.143,14.1a.594.594,0,0,1,.568-.425H33.47v0A.588.588,0,0,1,34.019,14.053ZM25.285,31.608c.046-1.212-.027-2.614-.027-3.791a1.626,1.626,0,1,0-3.247,0v3.791Zm9.671-11.9-1.888-4.853H30.3v4.853Zm-5.838-4.853h-5.1v4.853h5.1V14.856Zm-6.285,0H20.112L18.22,19.709h4.614V14.856ZM35.269,20.89h-5a2.509,2.509,0,0,0,4.641,1.189A2.466,2.466,0,0,0,35.269,20.89Zm-6.189,0H24.1a2.507,2.507,0,0,0,4.266,1.66A2.38,2.38,0,0,0,29.081,20.89Zm-6.177,0H17.911a2.515,2.515,0,0,0,4.278,1.66A2.344,2.344,0,0,0,22.9,20.89Zm10.073,5.266H29v2.208h3.977Z"
        transform="translate(4086.41 3737.768)"
        className="fillSvg"
      />
    </g>
  </svg>
);

export const ShopMiniSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 30"
  >
    <g id="Dev" transform="translate(-4098 -3746)">
      <rect
        id="Base"
        width="24"
        height="24"
        transform="translate(4098 3746)"
        fill="none"
      />
      <path
        id="Store"
        d="M34.019,14.053l1.876,4.818a3.664,3.664,0,0,1,.556,1.927,3.575,3.575,0,0,1-.471,1.784V32.2a.591.591,0,0,1-.591.591h-17.6A.593.593,0,0,1,17.2,32.2V22.581a3.634,3.634,0,0,1,.089-3.714L19.143,14.1a.594.594,0,0,1,.568-.425H33.47v0A.588.588,0,0,1,34.019,14.053ZM25.285,31.608c.046-1.212-.027-2.614-.027-3.791a1.626,1.626,0,1,0-3.247,0v3.791Zm9.671-11.9-1.888-4.853H30.3v4.853Zm-5.838-4.853h-5.1v4.853h5.1V14.856Zm-6.285,0H20.112L18.22,19.709h4.614V14.856ZM35.269,20.89h-5a2.509,2.509,0,0,0,4.641,1.189A2.466,2.466,0,0,0,35.269,20.89Zm-6.189,0H24.1a2.507,2.507,0,0,0,4.266,1.66A2.38,2.38,0,0,0,29.081,20.89Zm-6.177,0H17.911a2.515,2.515,0,0,0,4.278,1.66A2.344,2.344,0,0,0,22.9,20.89Zm10.073,5.266H29v2.208h3.977Z"
        transform="translate(4086.41 3737.768)"
        fill="rgba(255, 255, 255, 0.5)"
      />
    </g>
  </svg>
);

export const ShopMiniGreenSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 30"
  >
    <g id="Dev" transform="translate(-4098 -3746)">
      <rect
        id="Base"
        width="24"
        height="24"
        transform="translate(4098 3746)"
        fill="none"
      />
      <path
        id="Store"
        d="M34.019,14.053l1.876,4.818a3.664,3.664,0,0,1,.556,1.927,3.575,3.575,0,0,1-.471,1.784V32.2a.591.591,0,0,1-.591.591h-17.6A.593.593,0,0,1,17.2,32.2V22.581a3.634,3.634,0,0,1,.089-3.714L19.143,14.1a.594.594,0,0,1,.568-.425H33.47v0A.588.588,0,0,1,34.019,14.053ZM25.285,31.608c.046-1.212-.027-2.614-.027-3.791a1.626,1.626,0,1,0-3.247,0v3.791Zm9.671-11.9-1.888-4.853H30.3v4.853Zm-5.838-4.853h-5.1v4.853h5.1V14.856Zm-6.285,0H20.112L18.22,19.709h4.614V14.856ZM35.269,20.89h-5a2.509,2.509,0,0,0,4.641,1.189A2.466,2.466,0,0,0,35.269,20.89Zm-6.189,0H24.1a2.507,2.507,0,0,0,4.266,1.66A2.38,2.38,0,0,0,29.081,20.89Zm-6.177,0H17.911a2.515,2.515,0,0,0,4.278,1.66A2.344,2.344,0,0,0,22.9,20.89Zm10.073,5.266H29v2.208h3.977Z"
        transform="translate(4086.41 3737.768)"
        fill="#44BE84"
      />
    </g>
  </svg>
);

export const ThemeSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="30"
    viewBox="0 0 26 30"
  >
    <g id="noun_theme_2467169" transform="translate(-3 -1)">
      <g id="Layer_2" data-name="Layer 2">
        <path
          id="Path_3138"
          data-name="Path 3138"
          d="M26.13,6H25V5.19A4.19,4.19,0,0,0,20.81,1H7.19A4.19,4.19,0,0,0,3,5.19V8.81A4.19,4.19,0,0,0,7.19,13H20.81A4.19,4.19,0,0,0,25,8.81V8h1.13a.88.88,0,0,1,.88.88v5.25a.88.88,0,0,1-.87.88H15.59A2.6,2.6,0,0,0,13,17.59v1.49a2.62,2.62,0,0,0-2,2.54v6.75A2.63,2.63,0,0,0,13.63,31h.75A2.63,2.63,0,0,0,17,28.38V21.63a2.62,2.62,0,0,0-2-2.54v-1.5a.59.59,0,0,1,.59-.59H26.13A2.88,2.88,0,0,0,29,14.13V8.88A2.88,2.88,0,0,0,26.13,6Z"
          className="fillSvg"
        />
      </g>
    </g>
  </svg>
);

export const WebSvg = (
  <svg
    id="web"
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
  >
    <rect id="Base" width="40" height="40" fill="none" />
    <g id="noun_web_1213113" transform="translate(951.793 -948.207)">
      <path
        id="Path_3137"
        data-name="Path 3137"
        d="M-931.793,953.5A14.72,14.72,0,0,0-946.5,968.207a14.72,14.72,0,0,0,14.707,14.707,14.72,14.72,0,0,0,14.707-14.707A14.721,14.721,0,0,0-931.793,953.5Zm11.054,9.072h-3.715a17.383,17.383,0,0,0-2.229-5.7A12.494,12.494,0,0,1-920.739,962.572Zm1.362,5.635a11.948,11.948,0,0,1-.464,3.344h-4.211a29.424,29.424,0,0,0,.186-3.344,29.421,29.421,0,0,0-.186-3.344h4.242A13.2,13.2,0,0,1-919.377,968.207Zm-24.832,0a11.951,11.951,0,0,1,.464-3.344h4.242a29.45,29.45,0,0,0-.186,3.344,29.453,29.453,0,0,0,.186,3.344h-4.242A11.953,11.953,0,0,1-944.209,968.207Zm6.781,0a24.3,24.3,0,0,1,.248-3.344h4.273v6.688h-4.273A24.307,24.307,0,0,1-937.428,968.207Zm6.781-12.137c1.7.805,3.065,3.406,3.808,6.533h-3.808Zm-2.291,0V962.6h-3.808C-936,959.476-934.641,956.875-932.938,956.07Zm0,17.772v6.533c-1.7-.805-3.065-3.406-3.808-6.533Zm2.291,6.5v-6.533h3.808C-927.582,976.938-928.944,979.539-930.647,980.344Zm0-8.793v-6.688h4.273a24.3,24.3,0,0,1,.248,3.344,24.307,24.307,0,0,1-.248,3.344Zm-6.254-14.645a18.091,18.091,0,0,0-2.229,5.7h-3.716A12.217,12.217,0,0,1-936.9,956.906Zm-5.945,16.936h3.716a17.384,17.384,0,0,0,2.229,5.7A12.493,12.493,0,0,1-942.846,973.842Zm16.162,5.666a18.1,18.1,0,0,0,2.229-5.7h3.715A12.217,12.217,0,0,1-926.684,979.508Z"
        transform="translate(0 0)"
        className="fillSvg"
      />
    </g>
  </svg>
);

export const CameraSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="52.604"
    height="47.343"
    viewBox="0 0 52.604 47.343"
  >
    <path
      id="Icon"
      d="M503.411-104,498.6-98.74H490.26a5.276,5.276,0,0,0-5.26,5.26v31.562a5.276,5.276,0,0,0,5.26,5.26h42.083a5.276,5.276,0,0,0,5.26-5.26V-93.479a5.276,5.276,0,0,0-5.26-5.26h-8.338L519.192-104ZM511.3-64.547A13.156,13.156,0,0,1,498.151-77.7,13.156,13.156,0,0,1,511.3-90.849,13.156,13.156,0,0,1,524.453-77.7,13.156,13.156,0,0,1,511.3-64.547Zm0-4.734a8.417,8.417,0,0,0,8.417-8.417,8.417,8.417,0,0,0-8.417-8.417,8.417,8.417,0,0,0-8.417,8.417A8.417,8.417,0,0,0,511.3-69.282Z"
      transform="translate(-485 104)"
      fill="#d9d9d9"
      fillRule="evenodd"
    />
  </svg>
);

export const storeStaffIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="14"
    viewBox="0 0 22 14"
  >
    <path
      id="Icon"
      d="M179-16a2.987,2.987,0,0,0,2.99-3A2.987,2.987,0,0,0,179-22a3,3,0,0,0-3,3,3,3,0,0,0,3,3Zm-8,0a2.987,2.987,0,0,0,2.99-3A2.987,2.987,0,0,0,171-22a3,3,0,0,0-3,3,3,3,0,0,0,3,3Zm0,2c-2.33,0-7,1.17-7,3.5V-8h14v-2.5c0-2.33-4.67-3.5-7-3.5Zm8,0c-.29,0-.62.02-.97.05A4.22,4.22,0,0,1,180-10.5V-8h6v-2.5c0-2.33-4.67-3.5-7-3.5Z"
      transform="translate(-164 22)"
      className="fillSvg"
      fillRule="evenodd"
    />
  </svg>
);

export const searchSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="35"
    viewBox="0 0 35 35"
  >
    <g id="ic_search" transform="translate(-3997.999 -3796)">
      <rect
        id="Base"
        width="35"
        height="35"
        transform="translate(3997.999 3796)"
        fill="none"
      />
      <path
        id="Icon"
        d="M60.585-291.165h-.922l-.327-.315a7.551,7.551,0,0,0,1.832-4.936A7.584,7.584,0,0,0,53.584-304,7.584,7.584,0,0,0,46-296.416a7.584,7.584,0,0,0,7.584,7.584,7.551,7.551,0,0,0,4.936-1.832l.315.327v.922l5.834,5.822,1.739-1.739-5.822-5.834Zm-7,0a5.244,5.244,0,0,1-5.251-5.251,5.244,5.244,0,0,1,5.251-5.251,5.244,5.244,0,0,1,5.251,5.251,5.244,5.244,0,0,1-5.251,5.251Z"
        transform="translate(3960.168 4107.001)"
        fill="#bcbcbc"
        fill-rule="evenodd"
      />
    </g>
  </svg>
);

export const shopPublishedSvg = (
  <svg
    width="230"
    height="147"
    viewBox="0 0 230 147"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_50_970)">
      <rect
        x="64.158"
        y="20.6529"
        width="145.263"
        height="99.6198"
        rx="2"
        className="fillSvg"
      />
      <path
        d="M12.8938 146.571C9.34558 146.278 6.21295 143.7 4.43145 140.604C3.83401 139.566 3.42467 138.204 4.10122 137.216C4.29487 136.933 4.56249 136.709 4.8746 136.57C5.1867 136.43 5.53118 136.379 5.87007 136.424C6.20895 136.468 6.5291 136.605 6.79523 136.82C7.06136 137.036 7.26315 137.321 7.37836 137.644C7.16045 136.431 7.06681 135.199 7.09891 133.967C7.12618 132.924 7.32243 131.744 8.18605 131.164C9.18796 130.491 10.6321 131.025 11.3609 131.99C12.0896 132.954 12.2874 134.208 12.4623 135.406C12.3195 134.899 12.3055 134.364 12.4218 133.85C12.538 133.337 12.7806 132.86 13.1275 132.465C13.4744 132.07 13.9144 131.768 14.4073 131.588C14.9003 131.408 15.4303 131.355 15.949 131.433C17.4165 131.656 18.566 132.932 19.0146 134.353C19.4632 135.774 19.3231 137.314 19.0344 138.776C18.6959 140.491 18.1465 142.192 17.1573 143.63C16.1682 145.068 14.699 146.227 12.9943 146.579L12.8938 146.571Z"
        fill="#08AC4E"
      />
      <path
        d="M230.335 30.8344C230.335 37.2293 228.356 43.466 224.672 48.6816C220.988 53.8972 215.78 57.8339 209.771 59.9467C209.58 60.0136 209.386 60.0805 209.192 60.1416V28.8098H169C169.012 28.6149 169.026 28.42 169.043 28.2281H209.192V22.1077C209.192 21.722 209.039 21.3522 208.767 21.0794C208.496 20.8067 208.128 20.6534 207.744 20.6533H170.648C170.715 20.4584 170.784 20.2635 170.859 20.0715C173.372 13.2968 178.176 7.62418 184.43 4.0448C190.684 0.465405 197.991 -0.793237 205.076 0.488757C212.16 1.77075 218.57 5.51187 223.187 11.0585C227.804 16.6052 230.334 23.6048 230.335 30.8344Z"
        fill="#3F3D56"
      />
      <path
        d="M207.391 20.6529H66.1876C65.6495 20.6535 65.1336 20.8673 64.7531 21.2473C64.3726 21.6273 64.1586 22.1426 64.158 22.68V118.246C64.1586 118.783 64.3726 119.298 64.7531 119.678C65.1336 120.058 65.6495 120.272 66.1876 120.273H207.391C207.93 120.272 208.445 120.058 208.826 119.678C209.206 119.298 209.421 118.783 209.421 118.246V22.68C209.421 22.1426 209.206 21.6273 208.826 21.2473C208.445 20.8673 207.93 20.6535 207.391 20.6529ZM208.841 118.246C208.841 118.63 208.688 118.998 208.416 119.269C208.145 119.541 207.776 119.693 207.391 119.694H66.1876C65.8031 119.693 65.4345 119.541 65.1626 119.269C64.8908 118.998 64.738 118.63 64.7379 118.246V22.68C64.738 22.2961 64.8908 21.9279 65.1626 21.6563C65.4345 21.3848 65.8031 21.2322 66.1876 21.2321H207.391C207.776 21.2322 208.145 21.3848 208.416 21.6563C208.688 21.9279 208.841 22.2961 208.841 22.68V118.246Z"
        fill="#CFCFCF"
      />
      <path
        d="M209.147 28.228H64.6223V28.8098H209.147V28.228Z"
        fill="#CFCFCF"
      />
      <path
        d="M69.5461 26.1801C70.5059 26.1801 71.2839 25.3987 71.2839 24.4348C71.2839 23.4709 70.5059 22.6895 69.5461 22.6895C68.5864 22.6895 67.8083 23.4709 67.8083 24.4348C67.8083 25.3987 68.5864 26.1801 69.5461 26.1801Z"
        fill="#E74C3C"
      />
      <path
        d="M74.5422 26.1801C75.502 26.1801 76.28 25.3987 76.28 24.4348C76.28 23.4709 75.502 22.6895 74.5422 22.6895C73.5825 22.6895 72.8044 23.4709 72.8044 24.4348C72.8044 25.3987 73.5825 26.1801 74.5422 26.1801Z"
        fill="#DEAE3D"
      />
      <path
        d="M79.5381 26.1801C80.4978 26.1801 81.2758 25.3987 81.2758 24.4348C81.2758 23.4709 80.4978 22.6895 79.5381 22.6895C78.5783 22.6895 77.8003 23.4709 77.8003 24.4348C77.8003 25.3987 78.5783 26.1801 79.5381 26.1801Z"
        fill="#08AC4E"
      />
      <path
        d="M104.012 40.1429H78.5245C77.987 40.1435 77.4716 40.3582 77.0915 40.7399C76.7115 41.1216 76.4977 41.6392 76.4971 42.1791V67.7774C76.4977 68.3173 76.7115 68.8349 77.0915 69.2166C77.4716 69.5983 77.987 69.8131 78.5245 69.8137H104.012C104.549 69.8131 105.065 69.5983 105.445 69.2166C105.825 68.8349 106.039 68.3173 106.039 67.7774V42.1791C106.039 41.6392 105.825 41.1216 105.445 40.7399C105.065 40.3582 104.549 40.1435 104.012 40.1429ZM105.46 67.7774C105.46 68.1631 105.307 68.533 105.036 68.8057C104.764 69.0784 104.396 69.2317 104.012 69.2319H78.5245C78.1404 69.2317 77.7722 69.0784 77.5006 68.8057C77.2291 68.533 77.0765 68.1631 77.0763 67.7774V42.1791C77.0765 41.7934 77.2291 41.4235 77.5006 41.1508C77.7722 40.8781 78.1404 40.7248 78.5245 40.7246H104.012C104.396 40.7248 104.764 40.8781 105.036 41.1508C105.307 41.4235 105.46 41.7934 105.46 42.1791V67.7774Z"
        fill="#CFCFCF"
      />
      <path
        d="M149.773 40.2883H124.286C123.787 40.2893 123.308 40.4888 122.956 40.8432C122.603 41.1976 122.404 41.6779 122.403 42.1791V67.7774C122.404 68.2786 122.603 68.759 122.956 69.1134C123.308 69.4677 123.787 69.6672 124.286 69.6682H149.773C150.272 69.6672 150.75 69.4677 151.103 69.1134C151.456 68.759 151.655 68.2786 151.656 67.7774V42.1791C151.655 41.6779 151.456 41.1976 151.103 40.8432C150.75 40.4888 150.272 40.2893 149.773 40.2883Z"
        fill="#008AFF"
      />
      <path
        d="M195.534 40.2883H170.047C169.548 40.2893 169.07 40.4888 168.717 40.8432C168.364 41.1976 168.165 41.6779 168.164 42.1791V67.7774C168.165 68.2786 168.364 68.759 168.717 69.1134C169.07 69.4677 169.548 69.6672 170.047 69.6682H195.534C196.033 69.6672 196.511 69.4677 196.864 69.1134C197.217 68.759 197.416 68.2786 197.417 67.7774V42.1791C197.416 41.6779 197.217 41.1976 196.864 40.8432C196.511 40.4888 196.033 40.2893 195.534 40.2883Z"
        fill="#E6E6E6"
      />
      <path
        d="M104.012 78.6858H78.5244C78.0254 78.6868 77.5471 78.8863 77.1943 79.2407C76.8415 79.5951 76.6428 80.0754 76.6418 80.5766V106.175C76.6428 106.676 76.8415 107.156 77.1943 107.511C77.5471 107.865 78.0254 108.065 78.5244 108.066H104.012C104.511 108.065 104.989 107.865 105.342 107.511C105.695 107.156 105.893 106.676 105.894 106.175V80.5766C105.893 80.0754 105.695 79.5951 105.342 79.2407C104.989 78.8863 104.511 78.6868 104.012 78.6858Z"
        fill="#E6E6E6"
      />
      <path
        d="M149.773 78.6858H124.286C123.787 78.6868 123.308 78.8863 122.956 79.2407C122.603 79.5951 122.404 80.0754 122.403 80.5766V106.175C122.404 106.676 122.603 107.156 122.956 107.511C123.308 107.865 123.787 108.065 124.286 108.066H149.773C150.272 108.065 150.75 107.865 151.103 107.511C151.456 107.156 151.655 106.676 151.656 106.175V80.5766C151.655 80.0754 151.456 79.5951 151.103 79.2407C150.75 78.8863 150.272 78.6868 149.773 78.6858Z"
        fill="#008AFF"
      />
      <path
        d="M195.534 78.6858H170.047C169.548 78.6868 169.07 78.8863 168.717 79.2407C168.364 79.5951 168.165 80.0754 168.164 80.5766V106.175C168.165 106.676 168.364 107.156 168.717 107.511C169.07 107.865 169.548 108.065 170.047 108.066H195.534C196.033 108.065 196.511 107.865 196.864 107.511C197.217 107.156 197.416 106.676 197.417 106.175V80.5766C197.416 80.0754 197.217 79.5951 196.864 79.2407C196.511 78.8863 196.033 78.6868 195.534 78.6858Z"
        fill="#E6E6E6"
      />
      <path
        d="M97.7847 82.9037H72.2974C71.7983 82.9031 71.3197 82.7038 70.9668 82.3493C70.6139 81.9948 70.4154 81.5142 70.4148 81.0129V55.4146C70.4154 54.9133 70.6139 54.4327 70.9668 54.0782C71.3197 53.7238 71.7983 53.5244 72.2974 53.5238H97.7847C98.2838 53.5244 98.7623 53.7238 99.1152 54.0782C99.4681 54.4327 99.6667 54.9133 99.6672 55.4146V81.0129C99.6667 81.5142 99.4681 81.9948 99.1152 82.3493C98.7623 82.7038 98.2838 82.9031 97.7847 82.9037Z"
        fill="#008AFF"
      />
      <path
        d="M58.7209 143.144L62.1154 142.097L59.7126 128.449L54.7026 129.993L58.7209 143.144Z"
        fill="#EFB7B9"
      />
      <path
        d="M69.6294 143.245L58.9609 146.534L57.6959 142.394L64.2425 140.376C64.7838 140.209 65.3525 140.151 65.9162 140.205C66.4798 140.259 67.0274 140.424 67.5276 140.69C68.0279 140.957 68.4709 141.319 68.8315 141.758C69.1922 142.196 69.4633 142.702 69.6294 143.245Z"
        fill="#1A1F27"
      />
      <path
        d="M29.7586 143.222L33.3095 143.222L34.9986 129.466L29.7581 129.467L29.7586 143.222Z"
        fill="#EFB7B9"
      />
      <path
        d="M40.1575 146.533L28.9979 146.534L28.9977 142.203L35.8456 142.203C36.4118 142.203 36.9725 142.315 37.4956 142.532C38.0187 142.75 38.4941 143.069 38.8945 143.471C39.2949 143.873 39.6125 144.351 39.8292 144.876C40.0459 145.401 40.1574 145.964 40.1575 146.533L40.1575 146.533Z"
        fill="#1A1F27"
      />
      <path
        d="M29.504 103.348C29.2122 103.091 28.9801 102.773 28.824 102.416C28.6679 102.059 28.5915 101.673 28.6003 101.283C28.6091 100.894 28.7028 100.511 28.8748 100.162C29.0469 99.8123 29.2931 99.5052 29.5961 99.2619L32.3491 64.4439L37.9478 65.8488L33.4651 99.8127C33.8384 100.351 34.002 101.008 33.9251 101.66C33.8482 102.311 33.536 102.912 33.0478 103.347C32.5595 103.783 31.9291 104.024 31.2759 104.024C30.6228 104.024 29.9923 103.783 29.504 103.348Z"
        fill="#EFB7B9"
      />
      <path
        d="M40.7156 50.9396C44.6443 50.9396 47.8292 47.7409 47.8292 43.795C47.8292 39.8492 44.6443 36.6505 40.7156 36.6505C36.7869 36.6505 33.6021 39.8492 33.6021 43.795C33.6021 47.7409 36.7869 50.9396 40.7156 50.9396Z"
        fill="#EFB7B9"
      />
      <path
        d="M34.5302 63.373C32.9251 61.1598 32.8757 58.1117 34.6047 55.9948C35.733 54.6133 37.6204 53.5078 40.7716 53.5078C49.1708 53.5078 52.3567 60.1983 52.3567 60.1983C52.3567 60.1983 55.8322 66.5979 53.8048 72.4157C51.7774 78.2335 51.7774 78.8153 51.7774 78.8153L38.4546 77.6517C38.4546 77.6517 40.7021 71.8829 34.5302 63.373Z"
        fill="#DCE6F2"
      />
      <path
        d="M30.4219 69.1642L33.292 59.7333C33.4842 59.1018 33.8122 58.5204 34.2527 58.0302C34.6933 57.54 35.2356 57.153 35.8415 56.8965C36.4473 56.64 37.1019 56.5202 37.7589 56.5457C38.4158 56.5712 39.0592 56.7413 39.6436 57.044C40.6574 57.5713 41.4336 58.4661 41.8148 59.547C42.196 60.6279 42.1537 61.8139 41.6964 62.8646L38.0476 71.2106L30.4219 69.1642Z"
        fill="#DCE6F2"
      />
      <path
        d="M51.4878 77.3608L62.7833 136.121L56.7011 137.866L41.93 99.1776L35.2686 138.739L28.8968 139.611C28.8968 139.611 26.1018 87.2671 38.4545 77.6517L51.4878 77.3608Z"
        fill="#005843"
      />
      <path
        d="M67.745 74.6068C67.6419 74.7301 67.5487 74.8613 67.4662 74.9993L53.1194 75.6979L50.3568 67.2273L45.5601 69.517L50.0747 82.1333L67.8179 78.6482C68.2349 79.1054 68.7805 79.4243 69.3823 79.5624C69.984 79.7005 70.6134 79.6514 71.1867 79.4215C71.76 79.1917 72.25 78.7919 72.5916 78.2755C72.9332 77.7592 73.1101 77.1505 73.0989 76.5307C73.0877 75.9108 72.8889 75.309 72.5289 74.8054C72.1689 74.3018 71.6648 73.9202 71.0836 73.7114C70.5024 73.5025 69.8717 73.4763 69.2753 73.6363C68.6789 73.7962 68.1451 74.1347 67.745 74.6068Z"
        fill="#EFB7B9"
      />
      <path
        d="M43.553 61.0431C43.4761 60.3873 43.5437 59.7225 43.7508 59.0958C43.9579 58.469 44.2995 57.8956 44.7516 57.4161C45.2036 56.9366 45.755 56.5626 46.3668 56.3206C46.9785 56.0787 47.6358 55.9747 48.292 56.0159C49.4313 56.0893 50.5002 56.5952 51.282 57.431C52.0637 58.2667 52.4997 59.3698 52.5016 60.5164V69.6315L44.7002 70.8371L43.553 61.0431Z"
        fill="#DCE6F2"
      />
      <path
        d="M42.2801 51.0044C41.2124 50.9998 40.3888 49.8708 40.4366 48.7995C40.4845 47.7282 41.2008 46.7857 42.0639 46.1545C42.927 45.5232 43.9392 45.1387 44.9017 44.6746C45.8642 44.2105 46.8183 43.6316 47.4126 42.7407C47.7716 42.1576 47.9859 41.4964 48.0374 40.8128C48.089 40.1292 47.9764 39.4432 47.7089 38.8124C47.1559 37.5508 46.2064 36.5061 45.0058 35.8383C43.2223 34.7898 41.1111 34.4545 39.0925 34.8993C37.074 35.344 35.2964 36.5362 34.1137 38.2382L32.8949 41.5712C31.6531 43.0711 31.4561 45.2985 32.2195 47.0922C32.9829 48.886 34.6084 50.2355 36.4426 50.8771C38.3035 51.4778 40.2957 51.5377 42.1891 51.0501"
        fill="#1A1F27"
      />
      <path
        d="M35.779 39.9039C35.2551 39.0606 34.347 38.5242 33.4082 38.2094C32.3206 37.8447 31.1638 37.7371 30.028 37.8949C28.8922 38.0526 27.808 38.4716 26.8597 39.1191C25.9115 39.7666 25.1249 40.6252 24.5611 41.628C23.9974 42.6308 23.6716 43.7508 23.6093 44.9007C23.5098 46.7375 24.0825 48.5336 24.419 50.3418C24.7555 52.15 24.8224 54.1472 23.8297 55.6931C23.0737 56.8705 21.8128 57.6119 20.5683 58.2449C19.5311 58.7725 18.4091 59.2676 17.2511 59.1625C16.0932 59.0574 14.9294 58.1362 14.9601 56.9689C14.5724 57.8058 14.3107 58.696 14.1834 59.6102C14.102 60.5283 14.3272 61.5188 14.9874 62.159C15.947 63.0894 17.4674 63.0214 18.7861 62.8206C21.641 62.386 24.5318 61.5711 26.7872 59.7603C29.0427 57.9496 30.5393 54.9679 29.9453 52.1299C29.6972 50.9444 29.1141 49.8621 28.6429 48.747C28.1717 47.6318 27.8039 46.412 28.0203 45.2202C28.1485 44.6062 28.4092 44.028 28.7842 43.5263C29.1591 43.0245 29.6392 42.6116 30.1904 42.3166C31.3052 41.7344 32.5808 41.5402 33.8173 41.7642C34.628 41.8978 35.6402 42.1053 36.1211 41.4363C36.2485 41.2243 36.3136 40.9805 36.3088 40.7329C36.304 40.4854 36.2295 40.2443 36.0939 40.0375C35.8165 39.6284 35.4632 39.2769 35.0534 39.002"
        fill="#1A1F27"
      />
      <path
        d="M89.3459 147H0.344884C0.299512 147 0.254558 146.991 0.212603 146.974C0.170648 146.957 0.132515 146.931 0.100386 146.899C0.0682573 146.867 0.042765 146.829 0.0253717 146.786C0.0079785 146.744 -0.000976562 146.699 -0.000976562 146.654C-0.000976562 146.608 0.0079785 146.563 0.0253717 146.521C0.042765 146.479 0.0682573 146.441 0.100386 146.408C0.132515 146.376 0.170648 146.351 0.212603 146.333C0.254558 146.316 0.299512 146.307 0.344884 146.307H89.3459C89.3912 146.307 89.4362 146.316 89.4781 146.333C89.5201 146.351 89.5582 146.376 89.5903 146.408C89.6225 146.441 89.648 146.479 89.6654 146.521C89.6828 146.563 89.6917 146.608 89.6917 146.654C89.6917 146.699 89.6828 146.744 89.6654 146.786C89.648 146.829 89.6225 146.867 89.5903 146.899C89.5582 146.931 89.5201 146.957 89.4781 146.974C89.4362 146.991 89.3912 147 89.3459 147Z"
        fill="#3F3D56"
      />
    </g>
    <defs>
      <clipPath id="clip0_50_970">
        <rect width="230" height="147" className="fillSvg" />
      </clipPath>
    </defs>
  </svg>
);
export const copySvg = (
  <svg
    style={{
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      overflow: "hidden",
      transform: "Scale(1.5)",
    }}
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className="fillSvg"
  >
    <path d="M704 230h180c6.6 0 12-5.4 12-12 0-16.4-7.4-32-20-42.6l-154.2-128.4c-9.8-8.2-28.4-14.8-41.2-14.8-8.2 0-14.8 6.6-14.8 14.8V192c0.2 21 17.2 38 38.2 38z" />
    <path d="M614 192V32H352c-35.2 0-64 28.8-64 64v672c0 35.2 28.8 64 64 64h480c35.2 0 64-28.8 64-64V282h-192c-49.6 0-90-40.4-90-90z" />
    <path d="M232 824V160H192c-35.2 0-64 28.8-64 64v704c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-40H296c-35.2 0-64-28.8-64-64z" />
  </svg>
);

export const ConfigShopSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_301_31)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4441 8.51129L17.9433 4.65689C17.9093 4.56796 17.8491 4.49144 17.7707 4.43745C17.6923 4.38345 17.5993 4.35453 17.5041 4.35449H6.49691C6.39467 4.35474 6.29524 4.38796 6.21338 4.44921C6.13152 4.51046 6.0716 4.59648 6.04251 4.69449L4.55931 8.50809C4.28125 8.95113 4.12787 9.46099 4.11534 9.98391C4.10281 10.5068 4.23159 11.0234 4.48811 11.4793V19.1745C4.48853 19.2995 4.53826 19.4193 4.62649 19.5078C4.71472 19.5963 4.83433 19.6465 4.95931 19.6473H13.9906C13.2556 18.922 12.8 17.9142 12.8 16.8C12.8 14.5909 14.5909 12.8 16.8 12.8C17.8466 12.8 18.7992 13.2019 19.5121 13.8598V11.4801C19.7604 11.0455 19.8904 10.5534 19.8889 10.0529C19.8869 9.50766 19.7329 8.97379 19.4441 8.51129ZM10.9509 16.7775C10.9648 17.4238 10.9792 18.0923 10.9561 18.7009H8.33691V15.6681C8.32711 15.4915 8.35343 15.3147 8.41427 15.1486C8.47511 14.9825 8.56919 14.8305 8.69076 14.702C8.81233 14.5735 8.95883 14.4712 9.1213 14.4012C9.28378 14.3313 9.45882 14.2952 9.63571 14.2952C9.81261 14.2952 9.98765 14.3313 10.1501 14.4012C10.3126 14.4712 10.4591 14.5735 10.5807 14.702C10.7022 14.8305 10.7963 14.9825 10.8572 15.1486C10.918 15.3147 10.9443 15.4915 10.9345 15.6681C10.9345 16.0186 10.9426 16.3941 10.9509 16.7775ZM17.1825 5.29849L18.6929 9.18089H14.9681V5.29849H17.1825ZM9.94251 5.29849H14.0225V5.29929V9.18089H9.94251V5.29849ZM6.81771 5.29849H8.99451L8.99531 5.29929V9.18169H5.30411L6.81771 5.29849ZM14.9433 10.1265H18.9433C18.9303 10.4629 18.8314 10.7903 18.6561 11.0777C18.4314 11.442 18.096 11.7249 17.6991 11.8851C17.3021 12.0453 16.8644 12.0744 16.4497 11.9682C16.0351 11.8619 15.6652 11.6259 15.3942 11.2946C15.1232 10.9633 14.9652 10.554 14.9433 10.1265ZM10.0081 10.1265H13.9921H13.9929C13.9843 10.6272 13.7788 11.1043 13.4209 11.4545C13.1455 11.7267 12.7971 11.9133 12.4179 11.9918C12.0387 12.0703 11.6449 12.0373 11.284 11.8969C10.9231 11.7565 10.6106 11.5146 10.3842 11.2004C10.1578 10.8863 10.0272 10.5133 10.0081 10.1265ZM5.05691 10.1265H9.04811C9.04582 10.3745 8.99437 10.6195 8.89673 10.8475C8.7991 11.0754 8.65722 11.2817 8.47931 11.4545C8.20318 11.7269 7.85418 11.9137 7.47434 11.9924C7.0945 12.0711 6.7 12.0383 6.33836 11.898C5.97673 11.7577 5.66337 11.5158 5.43601 11.2015C5.20866 10.8872 5.07701 10.5139 5.05691 10.1265Z"
        fill="#44BE84"
      />
      <path
        d="M19.2797 17.2613C19.2981 17.0871 19.3043 16.9129 19.2859 16.7447L19.9425 16.2342C20.0038 16.1862 20.0161 16.1081 19.9793 16.042L19.3472 14.967C19.3104 14.9009 19.2306 14.8769 19.157 14.9009L18.3715 15.2012C18.2304 15.0991 18.077 15.015 17.9113 14.9489L17.7885 14.1321C17.7763 14.0541 17.7149 14 17.6351 14H16.3649C16.2912 14 16.2237 14.0541 16.2115 14.1261L16.0887 14.9429C15.9292 15.009 15.7758 15.0991 15.6346 15.1952L14.8491 14.8949C14.7755 14.8649 14.6957 14.8949 14.6589 14.961L14.0268 16.036C13.99 16.1021 14.0023 16.1802 14.0637 16.2282L14.7203 16.7447C14.7019 16.9189 14.6957 17.0931 14.7141 17.2613L14.0575 17.7718C13.9962 17.8198 13.9839 17.8979 14.0207 17.964L14.6528 19.039C14.6896 19.1051 14.7694 19.1291 14.843 19.1051L15.6223 18.8048C15.7635 18.9069 15.9169 18.991 16.0826 19.0571L16.2053 19.8739C16.2176 19.9459 16.279 20 16.3587 20H17.629C17.7026 20 17.7701 19.9459 17.7824 19.8739L17.9051 19.0571C18.0647 18.991 18.2181 18.9009 18.3592 18.8048L19.1447 19.1051C19.2184 19.1351 19.2981 19.1051 19.335 19.039L19.967 17.964C20.0038 17.8979 19.9916 17.8198 19.9302 17.7718L19.2797 17.2613ZM17.0031 17.9039C16.4937 17.9039 16.0826 17.5015 16.0826 17.003C16.0826 16.5045 16.4937 16.1021 17.0031 16.1021C17.5124 16.1021 17.9235 16.5045 17.9235 17.003C17.9235 17.5015 17.5124 17.9039 17.0031 17.9039Z"
        fill="#44BE84"
      />
    </g>
    <defs>
      <clipPath id="clip0_301_31">
        <rect width="24" height="24" className="fillSvg" />
      </clipPath>
    </defs>
  </svg>
);

export const ListOnShopSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_332_797)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9433 4.65689L19.4441 8.51129C19.7329 8.97379 19.8869 9.50766 19.8889 10.0529C19.8904 10.5534 19.7604 11.0455 19.5121 11.4801V15.0338C18.9787 14.6357 18.3169 14.4 17.6 14.4C15.8327 14.4 14.4 15.8327 14.4 17.6C14.4 18.3787 14.6782 19.0924 15.1406 19.6473H4.95931C4.83433 19.6465 4.71472 19.5963 4.62649 19.5078C4.53826 19.4193 4.48853 19.2995 4.48811 19.1745V11.4793C4.23159 11.0234 4.10281 10.5068 4.11534 9.98391C4.12787 9.46098 4.28125 8.95113 4.55931 8.50809L6.04251 4.69449C6.0716 4.59648 6.13152 4.51046 6.21338 4.44921C6.29524 4.38796 6.39467 4.35474 6.49691 4.35449H17.5041C17.5993 4.35453 17.6923 4.38345 17.7707 4.43745C17.8491 4.49144 17.9093 4.56796 17.9433 4.65689ZM10.9561 18.7009C10.9792 18.0923 10.9648 17.4238 10.9509 16.7775C10.9426 16.3942 10.9345 16.0186 10.9345 15.6681C10.9443 15.4915 10.918 15.3147 10.8572 15.1486C10.7963 14.9825 10.7022 14.8305 10.5807 14.702C10.4591 14.5735 10.3126 14.4712 10.1501 14.4012C9.98765 14.3313 9.81261 14.2952 9.63571 14.2952C9.45882 14.2952 9.28378 14.3313 9.1213 14.4012C8.95883 14.4712 8.81233 14.5735 8.69076 14.702C8.56919 14.8305 8.47511 14.9825 8.41427 15.1486C8.35343 15.3147 8.32711 15.4915 8.33691 15.6681V18.7009H10.9561ZM18.6929 9.18089L17.1825 5.29849H14.9681V9.18089H18.6929ZM14.0225 5.29849H9.94251V9.18089H14.0225V5.29849ZM8.99451 5.29849H6.81771L5.30411 9.18169H8.99531V5.29929L8.99451 5.29849ZM18.9433 10.1265H14.9433C14.9652 10.554 15.1232 10.9633 15.3942 11.2946C15.6652 11.6259 16.0351 11.8619 16.4497 11.9682C16.8644 12.0744 17.3021 12.0453 17.6991 11.8851C18.096 11.7249 18.4314 11.442 18.6561 11.0777C18.8314 10.7903 18.9303 10.4629 18.9433 10.1265ZM13.9921 10.1265H10.0081C10.0272 10.5133 10.1578 10.8863 10.3842 11.2004C10.6106 11.5146 10.9231 11.7565 11.284 11.8969C11.6449 12.0373 12.0387 12.0703 12.4179 11.9918C12.7971 11.9133 13.1454 11.7267 13.4209 11.4545C13.7788 11.1043 13.9835 10.6272 13.9921 10.1265ZM9.04811 10.1265H5.05691C5.07701 10.5139 5.20866 10.8872 5.43601 11.2015C5.66337 11.5158 5.97673 11.7577 6.33837 11.898C6.7 12.0383 7.0945 12.0711 7.47434 11.9924C7.85418 11.9137 8.20318 11.7269 8.47931 11.4545C8.65722 11.2817 8.7991 11.0754 8.89673 10.8475C8.99437 10.6195 9.04582 10.3745 9.04811 10.1265Z"
        className="fillSvg"
      />
      <path
        d="M18.2 17V15.2H17V17H15.2V18.2H17V20H18.2V18.2H20V17H18.2Z"
        className="fillSvg"
      />
    </g>
    <defs>
      <clipPath id="clip0_332_797">
        <rect width="24" height="24" className="fillSvg" />
      </clipPath>
    </defs>
  </svg>
);
